{
  "LOGIN": {
    "TITLE": "Bon retour",
    "SUBTITLE": "Entrez vos identifiants pour accéder à votre compte",
    "EMAIL_PLACEHOLDER": "vous@exemple.com",
    "PASSWORD_LABEL": "Mot de passe",
    "SUBMIT": "Se connecter",
    "SUBMITTING": "Connexion…",
    "QUICK_LOGIN": "Accès rapide",
    "QUICK_SUPER_ADMIN": "Super Admin",
    "QUICK_ADMIN": "Admin",
    "FORGOT_PASSWORD": "Mot de passe oublié ?"
  },

  "FORGOT_PASSWORD": {
    "TITLE": "Réinitialiser le mot de passe",
    "SUBTITLE": "Entrez votre e-mail et nous vous enverrons les instructions",
    "CHECK_INBOX": "Vérifiez votre boîte de réception",
    "EMAIL_SENT": "Nous avons envoyé un lien de récupération à votre e-mail",
    "EMAIL_LABEL": "Adresse e-mail",
    "EMAIL_PLACEHOLDER": "name@company.com",
    "SEND_INSTRUCTIONS": "Envoyer les instructions",
    "SENDING": "Envoi…",
    "SENT_TO": "Envoyé à",
    "CHECK_SPAM": "Vous n'avez pas reçu l'e-mail ? Vérifiez vos indésirables ou réessayez.",
    "TRY_ANOTHER_EMAIL": "Essayer une autre adresse e-mail",
    "BACK_TO_LOGIN": "Retour à la connexion"
  },

  "MOBILE": {
    "HUB_TITLE": "Welty",
    "HUB_SCREEN_TITLE": "Accueil",
    "BACK": "Retour"
  },

  "PWA_INSTALL": {
    "BANNER_LABEL": "Installer l'application",
    "TITLE": "Installer Welty sur votre téléphone",
    "ANDROID_HINT": "Ajoutez Welty à votre écran d'accueil pour un accès rapide.",
    "ANDROID_MANUAL": "Ouvrez le menu du navigateur (⋮), puis appuyez sur « Installer l'application » ou « Ajouter à l'écran d'accueil ». Sur un serveur de développement en Wi‑Fi, ce bouton peut être absent — utilisez « Ajouter à l'écran d'accueil » dans le même menu.",
    "IOS_INSTRUCTIONS": "Appuyez sur le bouton Partager, puis choisissez « Sur l'écran d'accueil ».",
    "INSTALL": "Installer",
    "LATER": "Pas maintenant"
  },

  "COMMON": {
    "LOGOUT": "Déconnexion",
    "ACTIONS": "Actions",
    "LOADING": "Chargement…",
    "SAVING": "Enregistrement…",
    "SELECT_PLACEHOLDER": "Sélectionner…",
    "PER_PAGE": "par page",
    "PREV": "Préc.",
    "NEXT": "Suiv.",
    "NO_DATA": "Aucune donnée",
    "CANCEL": "Annuler",
    "ERROR": "Erreur",
    "EDIT": "Modifier",
    "CLOSE": "Fermer",
    "SAVE": "Enregistrer",
    "SAVE_SUCCESS": "Enregistré avec succès.",
    "CREATE_SUCCESS": "Créé avec succès.",
    "UPDATE_SUCCESS": "Mis à jour avec succès.",
    "DELETE_SUCCESS": "Supprimé avec succès.",
    "COPIED": "Copié dans le presse-papiers.",
    "COPY_FAILED": "Impossible de copier."
  },

  "CONFIRM_MODAL": {
    "CONFIRM": "Confirmer",
    "CANCEL": "Annuler",
    "DELETE": "Supprimer"
  },

  "ADMIN": {
    "OVERVIEW": "Vue d'ensemble",
    "TENANTS": "Tenants",
    "ACCOUNT": "Compte",
    "SHOWCASE": "Vitrine",
    "TENANT_BLOCK_CONFIRM_TITLE": "Confirmer le blocage",
    "TENANT_BLOCK_CONFIRM_MESSAGE": "Voulez-vous vraiment bloquer ce tenant ?\n<strong>{{name}}</strong>",
    "TENANT_UNBLOCK_CONFIRM_TITLE": "Confirmer le déblocage",
    "TENANT_UNBLOCK_CONFIRM_MESSAGE": "Voulez-vous vraiment débloquer ce tenant ?\n<strong>{{name}}</strong>",
    "TENANT_REMOVE_USER_CONFIRM_TITLE": "Confirmer le retrait",
    "TENANT_REMOVE_USER_CONFIRM_MESSAGE": "Voulez-vous vraiment retirer cet utilisateur du tenant ?\n<strong>{{name}}</strong>",
    "TENANT_INVITE_DELETE_CONFIRM_TITLE": "Annuler l'invitation",
    "TENANT_INVITE_DELETE_CONFIRM_MESSAGE": "Voulez-vous vraiment annuler cette invitation ?\n<strong>{{email}}</strong>",
    "TENANT_INVITE_RENEW_CONFIRM_TITLE": "Renouveler l'invitation",
    "TENANT_INVITE_RENEW_CONFIRM_MESSAGE": "Voulez-vous vraiment renouveler cette invitation ?\n<strong>{{email}}</strong>",
    "TENANT_INVITE_RESEND_CONFIRM_TITLE": "Renvoyer l'invitation",
    "TENANT_INVITE_RESEND_CONFIRM_MESSAGE": "Voulez-vous vraiment renvoyer cette invitation ?\n<strong>{{email}}</strong>",
    "USER_ROLE_UPDATE_ERROR": "Impossible de mettre à jour le rôle de l'utilisateur.",
    "INVITES_LOAD_FAILED": "Impossible de charger les invitations.",
    "INVITE_CREATE_FAILED": "Impossible de créer l'invitation.",
    "INVITE_RENEW_FAILED": "Impossible de renouveler l'invitation.",
    "INVITE_RESEND_FAILED": "Impossible de renvoyer l'invitation.",
    "INVITE_DELETE_FAILED": "Impossible d'annuler l'invitation.",
    "INVITE_RENEWED_SUCCESS": "Invitation renouvelée. Un nouvel e-mail a été envoyé.",
    "INVITE_RESENT_SUCCESS": "Invitation renvoyée avec succès.",
    "SUPER_ADMIN_INVITE_FAILED": "Impossible d'envoyer l'invitation.",
    "WHATSAPP": {
      "TITLE": "WhatsApp / Twilio",
      "SYNC_TWILIO": "Synchroniser les numéros depuis Twilio",
      "PENDING_REQUESTS": "Demandes de connexion en attente",
      "NO_PENDING": "Aucune demande en attente.",
      "COL_TENANT": "Tenant",
      "COL_NUMBER": "Attribuer un numéro",
      "COL_ASSIGNED": "Tenant attribué",
      "COL_E164": "E.164",
      "COL_SID": "SID",
      "USAGE_CATEGORY": "Catégorie",
      "USAGE_COUNT": "Nombre",
      "USAGE_PRICE": "Prix",
      "SELECT_NUMBER": "Sélectionner un numéro…",
      "APPROVE": "Approuver",
      "REJECT": "Rejeter",
      "NO_INVENTORY": "Aucun numéro de téléphone dans l'inventaire. Synchronisez depuis Twilio pour charger les numéros.",
      "INVENTORY": "Inventaire des numéros",
      "USAGE": "Utilisation (Twilio)",
      "COL_ACTIONS": "Actions",
      "DISCONNECT": "Déconnecter",
      "DISCONNECT_CONFIRM": "Déconnecter WhatsApp pour le tenant utilisant {{e164}} ? Le numéro sera disponible pour une réattribution.",
      "DISCONNECT_SUCCESS": "WhatsApp déconnecté. Le numéro est à nouveau disponible.",
      "DISCONNECT_ERROR": "Impossible de déconnecter WhatsApp pour ce tenant."
    }
  },

  "NAV": {
    "DASHBOARD": "Tableau de bord",
    "CONVERSATIONS": "Conversations",
    "NOTIFICATIONS": "Notifications",
    "CONTACTS": "Contacts",
    "KNOWLEDGE_BASE": "Base de connaissances",
    "FLOWS": "Flux",
    "SERVICES": "Services",
    "APPOINTMENTS": "Rendez-vous",
    "COLLABORATORS": "Collaborateurs",
    "INSIGHTS": "Analyses",
    "FLOOR_PLAN": "Plan de salle",
    "FLOOR_PLAN_LIVE": "Salle (en direct)",
    "FLOOR_PLAN_ANALYTICS": "Analyses de salle",
    "FOOD_SETTINGS": "Paramètres restaurant",
    "SETTINGS": "Paramètres",
    "SECTION_FOOD": "Services de restauration",
    "SECTION_PERSONAL_CARE": "Soins personnels"
  },

  "FOOD_SETTINGS": {
    "TITLE": "Paramètres restaurant et réservations",
    "SUBTITLE": "Les horaires d'ouverture s'appliquent aux réservations de table via le chat et aux réservations du personnel dans la salle en direct. Chaque jour de la semaine utilise l'UTC (comme les dates du calendrier opérationnel).",
    "HERO_EYEBROW": "Restauration · Réservations",
    "LOADING": "Chargement…",
    "SAVE": "Enregistrer",
    "SAVE_SUCCESS": "Paramètres restaurant enregistrés.",
    "ERROR_LOAD": "Impossible de charger les paramètres restaurant.",
    "ERROR_SAVE": "Impossible d'enregistrer les paramètres restaurant.",
    "INVALID_DAY_HOURS": "Une ou plusieurs heures sont invalides. Utilisez le format 24 h (heures 00–23, minutes 00–59).",
    "MISSING_DAY_HOURS": "Définissez l'heure d'ouverture et de fermeture pour chaque jour ouvert.",
    "MISSING_DAY_INTERVALS": "Chaque jour ouvert doit avoir au moins une plage d'ouverture avec heures d'ouverture et de fermeture.",
    "CLOSE_NOT_AFTER_OPEN": "L'heure de fermeture doit être après l'ouverture le même jour calendaire, sauf pour les horaires de nuit (fermeture avant l'ouverture, ex. 22:00–02:00).",
    "SAME_OPEN_CLOSE": "L'heure d'ouverture et de fermeture ne peuvent pas être identiques.",
    "OVERNIGHT_LIMIT": "Une seule plage de nuit est autorisée par jour (par exemple 22:00–02:00).",
    "OVERLAPPING_INTERVALS": "Les plages d'ouverture du même jour ne peuvent pas se chevaucher.",
    "ADD_INTERVAL": "Ajouter des horaires d'ouverture",
    "REMOVE_INTERVAL_ARIA": "Supprimer cette plage d'ouverture",
    "INVALID_WEEKLY_SHAPE": "Les données d'horaires hebdomadaires sont incomplètes. Rechargez la page et réessayez.",
    "AT_LEAST_ONE_OPEN_DAY": "Conservez au moins un jour ouvert.",
    "SECTION_WEEKLY_HOURS": "Horaires par jour",
    "HINT_WEEKLY_UTC": "Pour chaque jour, ajoutez une ou plusieurs plages d'ouverture/fermeture (par exemple déjeuner et dîner), ou marquez comme fermé. Les jours vont de dimanche à samedi en UTC. Une fermeture à 00:00 signifie minuit à la fin de ce jour (pas le début du suivant). Pour un service de nuit réel (ex. 22:00–02:00), utilisez une heure de fermeture après 00:01.",
    "CLOSED": "Fermé",
    "OPENS": "Ouvre",
    "CLOSES": "Ferme",
    "SECTION_SLOTS": "Réservations et rotation des tables",
    "DURATION_MIN": "Durée de réservation par défaut (minutes)",
    "MIN_DURATION": "Séjour minimum des clients (minutes)",
    "MAX_DURATION": "Séjour maximum des clients (minutes)",
    "PREP_MIN": "Temps de préparation avant l'installation (minutes)",
    "COOLDOWN_MIN": "Temps de repos après le départ des clients (minutes)",
    "GRID_STEP": "Pas de la grille des heures de début (minutes)",
    "BUFFER_TOTAL": "Fenêtre typiquement bloquée par groupe : {{minutes}} minutes (préparation + durée par défaut + repos).",
    "MIN_MAX_DURATION": "Le séjour minimum ne peut pas être supérieur au séjour maximum.",
    "SECTION_NO_AVAIL": "Chat : message d'indisponibilité",
    "HINT_NO_AVAIL": "Affiché lorsque le chatbot ne trouve pas de table (après avoir essayé ±30 minutes). Variables : {date}, {time}, {partySize}, {restaurant}, {phone} (téléphone professionnel du profil du tenant). Le chatbot doit transmettre ce texte tel quel.",
    "NO_AVAIL_TEMPLATE": "Modèle de message",
    "NO_AVAIL_PLACEHOLDER": "Désolé, nous n'avons pas de table le {date} vers {time} pour {partySize} personnes.",
    "SECTION_PARTY_SIZE_EXCEEDED": "Chat : groupe trop important",
    "HINT_PARTY_SIZE_EXCEEDED": "Affiché lorsque le nombre de convives dépasse la plus grande table ou combinaison du plan de salle. Variables : {partySize}, {maxPartySize}, {date}, {restaurant}, {phone}. Le chatbot doit transmettre ce texte tel quel.",
    "PARTY_SIZE_EXCEEDED_TEMPLATE": "Modèle de message",
    "PARTY_SIZE_EXCEEDED_PLACEHOLDER": "Désolé, nous ne pouvons pas accueillir {partySize} personnes — notre plus grande configuration convient jusqu'à {maxPartySize}. Veuillez appeler le {phone} ou essayer un groupe plus petit.",
    "PREVIEW_LABEL": "Aperçu (valeurs d'exemple)",
    "SLOT_STEP": "Pas des créneaux (minutes)",
    "HINT_SLOTS": "Les heures de début proposées utilisent le pas de grille (ex. toutes les 15 minutes). La préparation et le repos prolongent le blocage de la table avant et après la fenêtre client. Les durées min/max permettent des séjours plus courts ou plus longs lorsque le planning le permet (y compris les créneaux partiels dans le chat).",
    "DAY_OPEN_LABEL": "Ouvert",
    "DAY_CLOSED_LABEL": "Fermé",
    "DAY_TOGGLE_ARIA": "Ouvrir ou fermer {{label}}",
    "DAY_OFF_HELP": "Les clients ne peuvent pas réserver ce jour. Activez l'interrupteur pour définir les horaires d'ouverture.",
    "CALLOUT_SLOTS": "Exemple : séjour par défaut 60 min, grille 15 min → débuts possibles toutes les 15 minutes si la table est libre pour le séjour complet plus les buffers. Les créneaux partiels dans le chat utilisent une fin plus courte lorsqu'il n'y a qu'un intervalle limité avant la prochaine réservation.",
    "WEEKDAYS": {
      "D0": "Dimanche",
      "D1": "Lundi",
      "D2": "Mardi",
      "D3": "Mercredi",
      "D4": "Jeudi",
      "D5": "Vendredi",
      "D6": "Samedi"
    }
  },

  "LAYOUT": {
    "DEFAULT_SECTION_LABEL": "Soins personnels",
    "CHANGE_TENANT": "Changer de tenant",
    "SELECT_TENANT": "Sélectionner un tenant…"
  },
  "NOTIFICATIONS_PAGE": {
    "SUBTITLE": "Éléments actionnables et non lus pour votre tenant.",
    "UNREAD": "Non lus",
    "READ": "Lus",
    "ACTION_NEEDED": "Action requise",
    "EMPTY_UNREAD": "Aucune notification non lue.",
    "EMPTY_READ": "Aucune notification lue pour le moment.",
    "EMPTY_ACTION_NEEDED": "Aucune action requise pour le moment.",
    "EMPTY_ALL": "Aucune notification.",
    "SYSTEM": "Système",
    "SYSTEM_COMING_SOON": "Les notifications système apparaîtront ici.",
    "FILTER_ALL": "Toutes",
    "FILTER_UNREAD": "Non lus",
    "FILTER_READ": "Lus",
    "FILTER_APPOINTMENTS": "Rendez-vous",
    "FILTER_APPOINTMENTS_UNREAD": "Rendez-vous - Non lus",
    "FILTER_CHAT": "Chat",
    "FILTER_CHAT_UNREAD": "Chat - Non lus",
    "FILTER_SYSTEM": "Système",
    "FILTER_NEW_MEMBER": "Nouveau membre",
    "TYPE_CHAT_INTERVENTION_NEEDED": "Intervention chat",
    "TYPE_SYSTEM_ERROR": "Erreur système",
    "TYPE_APPOINTMENT_NEW": "Nouveau rendez-vous",
    "TYPE_APPOINTMENT_CANCELLED": "Rendez-vous annulé",
    "TYPE_APPOINTMENT_MODIFIED": "Rendez-vous mis à jour",
    "TYPE_TENANT_NEW_MEMBER": "Nouveau membre de l'équipe",
    "COLUMN_TYPE": "Type",
    "COLUMN_TITLE": "Titre",
    "COLUMN_STATUS": "Statut",
    "COLUMN_DATE": "Date",
    "COLUMN_DETAILS": "Détails",
    "DETAILS_CREATED_AT": "Créé le",
    "DETAILS_APPOINTMENT_ID": "Rendez-vous",
    "DETAILS_ERROR_CODE": "Code d'erreur",
    "DETAILS_OPEN_CHAT": "Ouvrir le chat",
    "ACTION_GO_TO_AGENDA": "Aller à l'agenda",
    "ACTION_GO_TO_TEAM": "Aller à l'équipe"
  },

  "SIDEBAR": {
    "HELP_TITLE": "Besoin d'aide ?",
    "HELP_TEXT": "Contactez le support ou consultez les guides.",
    "COLLAPSE": "Réduire la barre latérale",
    "EXPAND": "Développer la barre latérale",
    "MAIN_NAV": "Navigation principale"
  },

  "SETTINGS": {
    "TABS": {
      "PROFILE": "Profil",
      "BUSINESS": "Entreprise",
      "NOTIFICATIONS": "Notifications",
      "APPEARANCE": "Apparence",
      "SECURITY": "Sécurité",
      "BILLING": "Facturation",
      "INTEGRATIONS": "Intégrations",
      "CHATBOT": "Chatbot"
    },
    "PROFILE_TITLE": "Paramètres du profil",
    "CHANGE_PHOTO": "Changer la photo",
    "PHOTO_HINT": "JPG, PNG ou GIF. Max. 2 Mo.",
    "FIRST_NAME": "Prénom",
    "LAST_NAME": "Nom",
    "EMAIL": "E-mail",
    "PHONE": "Téléphone",
    "PROFILE_SAVED": "Profil enregistré avec succès.",
    "SAVE_CHANGES": "Enregistrer les modifications",
    "SAVING": "Enregistrement…",
    "FOOD_SETTINGS_LINK": "Ouvrir les paramètres restaurant et réservations",
    "FOOD_SETTINGS_LINK_HINT": "Les horaires d'ouverture, jours ouvrés et durée de réservation sont sur une page dédiée.",
    "BUSINESS_TITLE": "Informations de l'entreprise",
    "UPLOAD_LOGO": "Téléverser le logo",
    "LOGO_HINT": "Taille recommandée 400x400 px.",
    "COMPANY_NAME": "Nom de l'entreprise",
    "INDUSTRY": "Secteur",
    "BUSINESS_ADDRESS": "Adresse de l'entreprise",
    "TAX_INFO_TITLE": "Informations fiscales",
    "VAT_ID": "N° de TVA",
    "CURRENCY": "Devise",
    "BUSINESS_SAVED": "Informations de l'entreprise enregistrées avec succès.",
    "SAVE_BUSINESS": "Enregistrer les infos entreprise",
    "COMM_PREFS_TITLE": "Préférences de notification",
    "COMM_PREFS_SUBTITLE": "Les canaux de diffusion s'appliquent à tous les membres de cet espace. Seuls les admins peuvent les modifier ; les opérateurs peuvent lier leur propre Telegram ci-dessous.",
    "NOTIF_ROW_APPOINTMENT_NEW": "Nouveau rendez-vous reçu",
    "NOTIF_ROW_APPOINTMENT_NEW_DESC": "Lorsqu'un client réserve via le chatbot ou des formulaires.",
    "NOTIF_ROW_APPOINTMENT_CANCELLED": "Rendez-vous annulé ou supprimé",
    "NOTIF_ROW_APPOINTMENT_CANCELLED_DESC": "Lorsqu'un rendez-vous est annulé ou retiré.",
    "NOTIF_ROW_APPOINTMENT_MODIFIED": "Rendez-vous modifié",
    "NOTIF_ROW_APPOINTMENT_MODIFIED_DESC": "Lorsque la date, l'heure, le service ou d'autres détails changent.",
    "NOTIF_ROW_TENANT_MEMBER": "Nouveau collaborateur ou admin",
    "NOTIF_ROW_TENANT_MEMBER_DESC": "Lorsque quelqu'un rejoint l'équipe de votre tenant.",
    "NOTIF_ROW_HUMAN_ASSISTANT": "Assistance humaine nécessaire",
    "NOTIF_ROW_HUMAN_ASSISTANT_DESC": "Lorsqu'une conversation nécessite l'attention d'un opérateur ou qu'il y a un problème de configuration du chatbot.",
    "NOTIF_MATRIX_EVENT": "Notification",
    "NOTIF_CHANNEL_IN_APP": "Liste dans l'app",
    "NOTIF_CHANNEL_EMAIL": "E-mail",
    "NOTIF_CHANNEL_TELEGRAM": "Telegram",
    "NOTIF_SAVE": "Enregistrer les préférences de notification",
    "NOTIF_TELEGRAM_INFO_TITLE": "Notifications Telegram",
    "NOTIF_TELEGRAM_INFO_DESC": "Une fois le bot de notifications connecté (Intégrations), toute personne qui ouvre le bot et appuie sur Start recevra automatiquement les alertes pour les événements avec Telegram activé ci-dessus. Appuyez sur /stop sur le bot pour vous désabonner.",
    "NOTIF_TELEGRAM_OPEN_BOT": "Ouvrir le bot sur Telegram",
    "NOTIF_TELEGRAM_BOT_NOT_CONNECTED": "Connectez d'abord le bot de notifications (onglet Intégrations).",
    "NOTIF_TELEGRAM_SUBSCRIBERS": "Abonnés actifs",
    "NOTIFICATION_PREFS": {
      "LOADING": "Chargement des préférences…",
      "NO_TENANT": "Sélectionnez un tenant pour gérer les préférences de notification.",
      "ERROR_LOAD": "Impossible de charger les préférences de notification.",
      "ERROR_SAVE": "Impossible d'enregistrer les préférences de notification."
    },
    "NOTIFICATIONS_TELEGRAM_BOT_TITLE": "Bot de notifications (tenant)",
    "NOTIFICATIONS_TELEGRAM_BOT_DESC": "Créez un bot Telegram séparé avec BotFather uniquement pour les notifications du personnel. Toute personne qui ouvre le bot et appuie sur Start recevra les alertes ; ce bot ne gère pas le chat client.",
    "NOTIFICATIONS_TELEGRAM": {
      "CONNECT": "Connecter le bot de notifications",
      "DISCONNECT": "Déconnecter le bot",
      "DISCONNECT_CONFIRM_TITLE": "Déconnecter le bot de notifications ?",
      "DISCONNECT_CONFIRM_MESSAGE": "Le personnel ne recevra plus de notifications Telegram tant qu'un nouveau bot n'est pas connecté.",
      "CONNECT_ERROR": "Impossible de connecter le bot de notifications.",
      "DISCONNECT_ERROR": "Impossible de déconnecter le bot de notifications.",
      "LINK_ERROR": "Impossible de démarrer la liaison Telegram. Vérifiez que le bot de notifications est connecté et réessayez.",
      "UNLINK_ERROR": "Impossible de dissocier Telegram."
    },
    "APPEARANCE_TITLE": "Apparence",
    "AI_AUTO_DISABLE_TITLE": "Désactivation auto de l'IA",
    "AI_AUTO_DISABLE_LABEL": "Désactiver l'IA après N réponses manquées",
    "AI_AUTO_DISABLE_DESC": "Mettez 0 pour désactiver cette fonctionnalité. Après N échecs consécutifs, le mode IA sera désactivé pour ce chat.",
    "AI_AUTO_DISABLE_SAVED": "Politique de désactivation auto de l'IA enregistrée.",
    "THEME_PREFERENCES": "Préférences de thème",
    "THEME_LIGHT": "Clair",
    "THEME_DARK": "Sombre",
    "SECURITY_TITLE": "Sécurité et connexion",
    "TWO_FA_TITLE": "Authentification à deux facteurs",
    "TWO_FA_DESC": "Ajoutez une couche de sécurité supplémentaire à votre compte en exigeant plus qu'un mot de passe pour vous connecter.",
    "SETUP_2FA": "Configurer la 2FA",
    "CHANGE_PASSWORD": "Changer le mot de passe",
    "CURRENT_PASSWORD": "Mot de passe actuel",
    "NEW_PASSWORD": "Nouveau mot de passe",
    "PASSWORD_UPDATED": "Mot de passe mis à jour avec succès.",
    "UPDATING": "Mise à jour…",
    "UPDATE_PASSWORD": "Mettre à jour le mot de passe",
    "ACTIVE_SESSIONS": "Sessions actives",
    "ACTIVE_NOW": "Active maintenant",
    "LAST_ACTIVE_AGO": "Dernière activité il y a 2 h",
    "BILLING_UNAVAILABLE": "La facturation n'est pas encore disponible.",
    "INTEGRATIONS_TITLE": "Intégrations",
    "CHATBOT_TITLE": "Messages du chatbot",
    "CHATBOT_IDENTIFICATION_TITLE": "Onboarding",
    "CHATBOT_KNOWLEDGE_BASE_TITLE": "Base de connaissances",
    "CHATBOT_ERRORS_TITLE": "Messages d'erreur",
    "CHATBOT_SAVED": "Messages du chatbot enregistrés avec succès.",
    "APPOINTMENT_CALENDARS": "Calendriers de rendez-vous",
    "GOOGLE_CALENDAR": "Google Calendar",
    "GOOGLE_CALENDAR_DESC": "Synchroniser automatiquement les rendez-vous",
    "MANAGE_CONNECTION": "Gérer la connexion",
    "APPLE_CALENDAR": "Apple Calendar",
    "APPLE_CALENDAR_DESC": "Synchronisation bidirectionnelle avec iCloud",
    "CONNECT": "Connecter",
    "CONVERSATIONS_SECTION": "Conversations",
    "WHATSAPP_BUSINESS": "WhatsApp Business",
    "CONNECTED": "Connecté :",
    "WHATSAPP_CONNECT_DESC": "Demandez un numéro WhatsApp. Un super admin en attribuera un après approbation.",
    "WHATSAPP_PENDING": "Demande en attente d'approbation.",
    "WHATSAPP_REJECTED": "Votre dernière demande a été rejetée. Vous pouvez en soumettre une nouvelle.",
    "REQUEST_WHATSAPP": "Demander la connexion",
    "DISCONNECT": "Déconnecter",
    "CONNECT_NUMBER": "Demander la connexion",
    "TELEGRAM_BOT": "Bot Telegram",
    "CHATBOT": {
      "WELCOME_MESSAGE": "Bonjour ! Je suis le bot. Pour continuer, j'ai besoin de quelques informations. Quel est votre prénom ?",
      "WELCOME_BACK_MESSAGE": "Bon retour ! Comment puis-je vous aider ?",
      "CONFIRMATION_MESSAGE": "Merci ! Vous êtes enregistré. Comment puis-je vous aider ?",
      "FIRST_NAME_QUESTION": "Quel est votre prénom ?",
      "LAST_NAME_QUESTION": "Quel est votre nom de famille ?",
      "PHONE_QUESTION": "Quel est votre numéro de téléphone ? (ex. 06 12 34 56 78)",
      "NO_INFORMATION_AVAILABLE": "Désolé, je n'ai pas d'information à ce sujet dans ma base de connaissances.",
      "ERROR_OCCURRED": "Une erreur s'est produite. Veuillez réessayer plus tard.",
      "ERROR_LOAD": "Impossible de charger les messages du chatbot.",
      "ERROR_SAVE": "Impossible d'enregistrer les messages du chatbot.",
      "SYSTEM_MESSAGES": {
        "TITLE": "Messages système",
        "SUBTITLE": "Personnalisez les messages automatiques envoyés par l'IA dans différentes situations. Si un champ est vide, le texte par défaut sera utilisé.",
        "PLACEHOLDER": "Saisir un texte personnalisé (optionnel)",
        "LABELS": {
          "WELCOME": "Message de bienvenue",
          "KB_NOT_FOUND": "Base de connaissances : info introuvable",
          "SYSTEM_ERROR": "Erreur système",
          "OUT_OF_HOURS": "Hors horaires d'ouverture",
          "HANDOFF_TO_HUMAN": "Transfert vers un opérateur humain",
          "NO_OPERATOR_AVAILABLE": "Aucun opérateur disponible",
          "BOOKING_CONFIRMED": "Réservation confirmée",
          "BOOKING_RESCHEDULED": "Réservation reportée",
          "BOOKING_CANCELLED": "Réservation annulée",
          "NO_AVAILABILITY_FOUND": "Aucune disponibilité trouvée",
          "FORM_SENT": "Formulaire envoyé à l'utilisateur",
          "FORM_COMPLETED_THANKS": "Formulaire complété — merci",
          "INPUT_NOT_UNDERSTOOD": "Saisie non comprise",
          "UNSUPPORTED_MEDIA": "Message non pris en charge (média/fichier)",
          "PRIVACY_CONSENT_REQUEST": "Demande de consentement (RGPD)",
          "PRIVACY_CONSENT_DENIED": "Consentement refusé",
          "CONVERSATION_CLOSED": "Conversation clôturée",
          "REACTIVATION": "Message de réactivation"
        }
      },
      "FOOD_DINING": {
        "TITLE": "Réservations de table via le chat",
        "SUBTITLE": "Entreprises de restauration uniquement : définissez le service utilisé lorsque l'IA crée des réservations de table (créez un service « Réservation de table » sous Services si besoin). Les horaires utilisent le même jour calendaire UTC que le plan de salle.",
        "SERVICE_ID": "ID du service de réservation de table",
        "SERVICE_HINT": "Identifiant MongoDB de 24 caractères depuis votre liste de Services.",
        "SERVICE_PLACEHOLDER": "ex. 674a1b2c3d4e5f6789012345",
        "DURATION": "Durée de réservation (minutes)",
        "DAY_START": "Première heure réservable (HH:mm)",
        "DAY_END": "Fin de journée pour le dernier créneau (HH:mm)",
        "SLOT_STEP": "Minutes entre les heures de début proposées",
        "SAVE": "Enregistrer les paramètres de réservation de table",
        "ERROR_SAVE": "Impossible d'enregistrer les paramètres de réservation de table."
      }
    },
    "TELEGRAM": {
      "SETUP_TITLE": "Configurer le bot Telegram",
      "SETUP_SUBTITLE": "Suivez les étapes pour créer et configurer votre bot Telegram",
      "CLOSE_ARIA": "Fermer",
      "QR_GENERATING": "Génération du code QR…",
      "QR_FALLBACK": "Si le code QR n'apparaît pas, utilisez le lien ci-dessous pour ouvrir BotFather",
      "QR_HINT": "Scannez le code QR avec Telegram pour ouvrir BotFather directement",
      "OPEN_BOTFATHER": "Ou ouvrir BotFather manuellement",
      "STEPS_TITLE": "Étapes à suivre :",
      "STEP_1_TITLE": "Ouvrir Telegram",
      "STEP_1_DESC": "Ouvrez l'application Telegram sur votre téléphone ou ordinateur",
      "STEP_2_TITLE": "Rechercher BotFather",
      "STEP_2_DESC": "Recherchez @BotFather dans la barre de recherche Telegram",
      "STEP_3_TITLE": "Créer un nouveau bot",
      "STEP_3_DESC": "Envoyez la commande /newbot à BotFather",
      "STEP_4_TITLE": "Configurer le bot",
      "STEP_4_DESC": "Choisissez un nom et un nom d'utilisateur pour votre bot (le nom d'utilisateur doit se terminer par « bot »)",
      "STEP_5_TITLE": "Copier le token",
      "STEP_5_DESC": "BotFather vous donnera un Bot Token. Copiez-le et collez-le ci-dessous",
      "BOT_TOKEN_LABEL": "Bot Token",
      "BOT_TOKEN_PLACEHOLDER": "123456789:ABCdefGHIjklMNOpqrsTUVwxyz",
      "BOT_TOKEN_HINT": "Collez ici le token fourni par BotFather après la création du bot",
      "TOKEN_REQUIRED": "Le token du bot est requis",
      "TOKEN_INVALID": "Format de token invalide. Le token doit être au format : nombre:caractères",
      "CANCEL": "Annuler",
      "CONNECT_BOT": "Connecter le bot",
      "CONNECTING": "Connexion…",
      "QR_MODAL_TITLE": "Code QR du bot",
      "QR_MODAL_HINT": "Scannez le code QR avec votre appareil photo pour ouvrir le bot sur Telegram",
      "DOWNLOAD_QR": "Télécharger l'image QR",
      "COPY_LINK": "Copier le lien",
      "LINK_COPIED": "Lien copié",
      "SHARE_BOT_LINK": "Partager le lien de votre bot",
      "OPEN_BOT_ON_TELEGRAM": "Ouvrir le bot sur Telegram",
      "QR_OR_SHARE": "Code QR / Partager",
      "BOT_CONNECTED_ACTIVE": "Bot connecté et actif",
      "INTEGRATE_BOT": "Intégrez votre bot pour les notifications et le chat.",
      "CONFIGURE_BOT": "Configurer le bot",
      "DISCONNECT_CONFIRM_TITLE": "Déconnecter Telegram",
      "DISCONNECT_CONFIRM_MESSAGE": "Voulez-vous vraiment déconnecter Telegram ? Les messages ne seront plus reçus.",
      "CONNECT_ERROR": "Erreur : vérifiez que le token du bot est valide. Obtenez-le auprès de @BotFather sur Telegram.",
      "DISCONNECT_ERROR": "Erreur lors de la déconnexion de Telegram."
    },
    "WHATSAPP_SHARE": {
      "CLOSE_ARIA": "Fermer",
      "QR_GENERATING": "Génération du code QR…",
      "QR_MODAL_TITLE": "Numéro WhatsApp",
      "QR_MODAL_HINT": "Scannez le code QR avec votre téléphone pour ouvrir un chat sur WhatsApp",
      "QR_IMAGE_ALT": "Code QR pour ouvrir un chat WhatsApp",
      "DOWNLOAD_QR": "Télécharger l'image QR",
      "COPY_LINK": "Copier le lien",
      "LINK_COPIED": "Lien copié",
      "SHARE_NUMBER": "Partager votre numéro WhatsApp Business",
      "OPEN_ON_WHATSAPP": "Ouvrir sur WhatsApp",
      "QR_OR_SHARE": "Code QR / Partager"
    },
    "WIDGET": {
      "TITLE": "Widget de chat site web",
      "DESCRIPTION_GENERATED": "Code du widget généré. Copiez le snippet pour intégrer le widget sur votre site.",
      "DESCRIPTION_NOT_GENERATED": "Générez un code de widget pour intégrer le chatbot sur votre site web.",
      "GENERATE_BUTTON": "Générer le code du widget",
      "REGENERATE_BUTTON": "Régénérer",
      "ENABLE_BUTTON": "Activer",
      "DISABLE_BUTTON": "Désactiver",
      "COPY_SNIPPET": "Copier le snippet",
      "TEST_WIDGET": "Tester le widget",
      "LOADING": "Chargement…",
      "ACTIVE": "Actif",
      "INACTIVE": "Inactif",
      "ERROR_NOT_GENERATED": "Code du widget non généré. Générez un code depuis Paramètres.",
      "ERROR_LOADING": "Erreur lors du chargement du statut du widget",
      "ERROR_GENERATING": "Échec de la génération du code du widget",
      "ERROR_TOGGLE": "Échec de la mise à jour du statut du widget",
      "REGENERATE_CONFIRM_TITLE": "Régénérer le code du widget",
      "REGENERATE_CONFIRM_MESSAGE": "Voulez-vous vraiment régénérer le code du widget ? L'ancien code cessera de fonctionner et vous devrez mettre à jour le snippet sur votre site.",
      "SNIPPET_COPIED": "Snippet copié dans le presse-papiers !"
    },
    "PROFILE": {
      "ERROR_SAVE": "Impossible d'enregistrer le profil."
    },
    "BUSINESS": {
      "ERROR_SAVE": "Impossible d'enregistrer les détails de l'entreprise."
    },
    "SECURITY": {
      "PASSWORD_ERROR": "Impossible de mettre à jour le mot de passe."
    },
    "AI_AUTO_DISABLE": {
      "ERROR_LOAD": "Impossible de charger les paramètres de désactivation auto de l'IA.",
      "ERROR_SAVE": "Impossible d'enregistrer les paramètres de désactivation auto de l'IA."
    },
    "INTEGRATIONS": {
      "POPUP_BLOCKED": "La fenêtre pop-up a été bloquée. Autorisez les pop-ups pour ce site pour continuer."
    },
    "WHATSAPP": {
      "DISCONNECT_ERROR": "Impossible de déconnecter WhatsApp.",
      "REQUEST_ERROR": "Impossible de soumettre la demande WhatsApp."
    }
  },

  "DASHBOARD": {
    "GOOD_MORNING": "Bonjour",
    "GOOD_AFTERNOON": "Bon après-midi",
    "GOOD_EVENING": "Bonsoir",
    "WELCOME_SUBTITLE": "Voici ce qui se passe dans votre activité aujourd'hui.",
    "QUICK_ACTIONS": "Actions rapides",
    "KEY_METRICS": "Indicateurs clés",
    "ACTIVITY": "Activité",
    "NEW_BOOKING": "Nouvelle réservation",
    "REPORTS": "Rapports",
    "TODAYS_AGENDA": "Agenda du jour",
    "SOON": "Bientôt",
    "LIVE_INBOX_TITLE": "Conversations en direct",
    "VIEW_ALL": "Tout voir ↗",
    "LIVE_INBOX_DESC": "Messages clients récents en attente de réponse",
    "OPEN_CHAT": "Ouvrir le chat",
    "AI_SUMMARY": "Résumé IA :",
    "INSIGHTS_TITLE": "Analyses du jour",
    "MOST_ASKED_TODAY": "Le plus demandé aujourd'hui :",
    "SUGGESTION": "Suggestion :",
    "DEFAULT_QUESTION": "Combien de temps dure la récupération ?",
    "DEFAULT_SUGGESTION": "3 clients ont demandé des conseils après soin. Envisagez d'ajouter une « Réponse rapide » pour les peelings.",
    "DEFAULT_TREND": "Conversion des réservations en hausse de 5 % vs la semaine dernière"
  },

  "TENANT_MODAL": {
    "TITLE_CREATE": "Créer un nouveau tenant",
    "TITLE_EDIT": "Modifier le tenant",
    "SUBTITLE": "Configurez les paramètres du tenant et les préférences IA.",
    "SECTION_BUSINESS_DETAILS": "Détails de l'entreprise",
    "SECTION_AI_SETTINGS": "Paramètres IA",
    "SECTION_AI_CONFIGURATION": "Configuration IA",
    "LABEL_AI_NAME": "NOM DE L'IA",
    "PLACEHOLDER_AI_NAME": "ex. Bot Support",
    "LABEL_AI_PERSONALITY": "PERSONNALITÉ ET TON DE L'IA",
    "PLACEHOLDER_AI_PERSONALITY": "Vous êtes un assistant de service client utile et poli. Vous parlez sur un ton formel…",
    "LABEL_AI_LIMITS": "LIMITES ET RÈGLES DE L'IA",
    "PLACEHOLDER_AI_LIMITS": "Ne répondez pas aux questions politiques. Ne donnez pas de conseils médicaux. Longueur max. de réponse : 50 mots…",
    "DESCRIPTION_AI_LIMITS": "Définissez des limites strictes et des règles opérationnelles pour le modèle IA.",
    "LABEL_BUSINESS_NAME": "NOM DE L'ENTREPRISE",
    "LABEL_EMAIL": "E-MAIL",
    "PLACEHOLDER_EMAIL": "name@company.com",
    "LABEL_PHONE": "TÉLÉPHONE",
    "LABEL_VERTICAL": "VERTICALE",
    "LABEL_TIER": "OFFRE",
    "LABEL_LANGUAGE": "LANGUE",
    "LABEL_AI_CONFIGURATIONS": "CONFIGURATIONS IA",
    "LABEL_AI_TYPE": "TYPE D'IA",
    "LABEL_MODEL": "MODÈLE",
    "LABEL_API_KEY": "CLÉ API",
    "LABEL_API_KEY_UPDATE": "CLÉ API (laisser vide pour conserver l'actuelle)",
    "PLACEHOLDER_API_KEY": "Saisir la clé API",
    "BUTTON_ADD_AI_CONFIG": "Ajouter une configuration IA",
    "BUTTON_CANCEL": "Annuler",
    "BUTTON_CREATE": "Créer le tenant",
    "BUTTON_UPDATE": "Mettre à jour le tenant",
    "BUTTON_CREATING": "Création…",
    "BUTTON_UPDATING": "Mise à jour…",
    "ERROR_CREATING": "Erreur lors de la création du tenant",
    "ERROR_UPDATING": "Erreur lors de la mise à jour du tenant"
  },

  "CONTACTS": {
    "TITLE": "Contacts",
    "MANAGE_FIELDS": "Gérer les champs",
    "UPLOAD_CONTACT_LIST": "Importer une liste de contacts",
    "ADD_CONTACT": "Ajouter un contact",
    "SEARCH_PLACEHOLDER": "Rechercher des contacts par nom, e-mail ou téléphone…",
    "FILTER_BY": "Filtrer par :",
    "ALL_CONTACTS": "Tous les contacts",
    "ACTIVE": "Actif",
    "INACTIVE": "Inactif",
    "NO_CONTACTS_FOUND": "Aucun contact trouvé",
    "SHOWING": "Affichage",
    "OF": "sur",
    "CONTACTS": "contacts",
    "DELETE_CONFIRM_TITLE": "Confirmer la suppression",
    "DELETE_CONFIRM": "Voulez-vous vraiment supprimer ce contact ?\n<strong>{{name}}</strong>",
    "ERROR_LOADING": "Erreur lors du chargement des contacts",
    "ERROR_DELETING": "Erreur lors de la suppression du contact",
    "DELETE_SUCCESS": "Contact supprimé avec succès.",
    "PLATFORMS": {
      "WHATSAPP": "WhatsApp",
      "TELEGRAM": "Telegram",
      "EMAIL": "E-mail",
      "MANUAL": "Manuel",
      "WEBCHAT": "Chat web"
    },
    "STATUS": {
      "ACTIVE": "Actif",
      "INACTIVE": "Inactif"
    },
    "LAST_ACTIVE": {
      "LABEL": "Dernière activité",
      "JUST_NOW": "À l'instant",
      "MINUTES_AGO": "il y a {{minutes}} min",
      "HOURS_AGO": "il y a {{hours}} h",
      "DAYS_AGO": "il y a {{days}} j",
      "WEEKS_AGO": "il y a {{weeks}} sem."
    },
    "MODAL": {
      "ADD_TITLE": "Ajouter un nouveau contact",
      "EDIT_TITLE": "Modifier le contact",
      "ADD_SUBTITLE": "Créer un nouveau profil dans votre espace de travail.",
      "EDIT_SUBTITLE": "Mettre à jour les informations du contact existant.",
      "BASIC_INFO": "Informations de base",
      "FULL_NAME": "Prénom",
      "FULL_NAME_PLACEHOLDER": "ex. Elena",
      "LAST_NAME": "Nom",
      "LAST_NAME_PLACEHOLDER": "ex. Rossi",
      "EMAIL_ADDRESS": "Adresse e-mail",
      "EMAIL_PLACEHOLDER": "name@example.com",
      "PHONE_NUMBER": "Numéro de téléphone",
      "PHONE_PLACEHOLDER": "+33 6 00 00 00 00",
      "PREFERENCES": "Préférences",
      "FAVOURITE_CONTACT_METHOD": "Moyen de contact préféré",
      "STATUS": "Statut",
      "ACTIVE_STATUS_LABEL": "Statut actif",
      "ACTIVE_STATUS_DESCRIPTION": "Ce contact est-il joignable ?",
      "CUSTOM_ATTRIBUTES": "Attributs personnalisés",
      "TAGS_LABELS": "Tags et libellés",
      "TAGS_ASSIGNED": "attribué(s)",
      "TAGS_PLACEHOLDER": "Sélectionner des tags…",
      "MORE_TAGS": "de plus +",
      "CANCEL": "Annuler",
      "CREATE_CONTACT": "Créer le contact",
      "UPDATE_CONTACT": "Mettre à jour le contact",
      "ERROR_CREATING": "Erreur lors de la création du contact",
      "ERROR_UPDATING": "Erreur lors de la mise à jour du contact",
      "YES": "Oui",
      "NO": "Non",
      "ENTER_FIELD_PLACEHOLDER": "Saisir {{label}}…"
    },
    "DETAIL": {
      "BACK": "Retour",
      "PAGE_TITLE": "Détails du contact",
      "SUBTITLE": "Voir et modifier les informations du contact",
      "NOT_FOUND": "Contact introuvable.",
      "DELETE": "Supprimer",
      "SAVE_SUCCESS": "Contact mis à jour avec succès.",
      "SUMMARY": {
        "TITLE": "Résumé IA du contact",
        "EMPTY": "Aucun résumé disponible.",
        "GENERATE": "Générer le résumé",
        "REFRESH": "Actualiser le résumé",
        "IN_PROGRESS": "Actualisation en cours",
        "REFRESH_STARTED": "Génération du résumé démarrée en arrière-plan.",
        "REFRESH_ERROR": "Impossible de démarrer la génération du résumé.",
        "STATUS_NOT_STARTED": "Non démarré",
        "STATUS_IN_PROGRESS": "En cours",
        "STATUS_COMPLETE": "Terminé",
        "STATUS_FAILED": "Échec",
        "STATUS_NEED_UPDATE": "Mise à jour nécessaire",
        "META_FIRST_COMPLETE": "Premier résumé terminé",
        "META_LAST_COMPLETED": "Dernier résumé terminé",
        "META_LAST_REQUESTED": "Dernière actualisation demandée",
        "META_SOURCE_UPDATED": "Dernière modification des données du contact",
        "META_VERSION": "Version du résumé",
        "META_NOT_AVAILABLE": "—",
        "NEED_UPDATE_HINT": "Les données du contact ont changé après le dernier résumé. Actualisez le résumé pour que l'assistant IA utilise des informations à jour."
      },
      "SUMMARY_CHAT": {
        "TITLE": "Assistant IA du contact",
        "SUBTITLE": "Réponses basées sur la KB du contact (résumé + rendez-vous) ; le résumé n'est pas régénéré",
        "READY": "Prêt",
        "LOCKED": "Verrouillé",
        "LOCK_HINT": "Générez le résumé au moins une fois pour activer le chat. Le chat est désactivé pendant la génération d'un nouveau résumé.",
        "HINT": "Posez une question — l'IA utilise uniquement le résumé enregistré, les rendez-vous et le texte des pièces jointes (sans régénération du résumé).",
        "PLACEHOLDER": "Tapez une question…",
        "INPUT_LOCKED": "Le chat est désactivé tant que le résumé n'est pas Terminé.",
        "AI_EMPTY": "L'IA a renvoyé une réponse vide. Réessayez ou actualisez le résumé.",
        "ERROR": "Je n'ai pas pu répondre pour le moment. Veuillez réessayer.",
        "RESPONDING": "Réflexion…"
      },
      "CONVERSATIONS": "Conversations",
      "NO_CONVERSATIONS": "Aucune conversation pour le moment.",
      "NO_MESSAGES": "Aucun message",
      "APPOINTMENTS": "Rendez-vous",
      "NO_APPOINTMENTS": "Aucun rendez-vous.",
      "FORMS": {
        "BUTTON": "Formulaire",
        "EMPTY": "Aucun formulaire pour ce rendez-vous.",
        "TYPE_REQUIRED": "Obligatoire",
        "TYPE_OPTIONAL": "Optionnel",
        "TYPE_UNKNOWN": "Type indisponible",
        "STATUS_SUBMITTED": "Soumis",
        "STATUS_PENDING": "Non soumis",
        "STATUS_EMPTY": "Indisponible",
        "PENDING_INFO": "Le client n'a pas encore rempli ce formulaire."
      }
    },
    "APPOINTMENT_DETAIL": {
      "PAGE_TITLE": "Rendez-vous",
      "SUBTITLE": "Notes et pièces jointes pour ce rendez-vous",
      "BACK_TO_CONTACT": "Retour au contact",
      "NOT_FOUND": "Rendez-vous introuvable.",
      "LOAD_ERROR": "Impossible de charger le rendez-vous.",
      "BASIC": "Détails",
      "SERVICE": "Service",
      "DATE": "Date",
      "TIME": "Heure",
      "STATUS": "Statut",
      "NOTES": "Notes",
      "NOTES_PLACEHOLDER": "Ajouter des notes pour ce rendez-vous…",
      "SAVE_NOTES": "Enregistrer les notes",
      "NOTES_SAVED": "Notes enregistrées.",
      "NOTES_SAVE_ERROR": "Impossible d'enregistrer les notes.",
      "ATTACHMENTS": "Pièces jointes",
      "ATTACHMENTS_HINT": "Glissez des fichiers ici ou cliquez pour sélectionner. Autorisés : PDF, documents Office, images, TXT.",
      "SELECT_FILES": "Choisir des fichiers",
      "UPLOADING": "Téléversement…",
      "UPLOAD_SUCCESS": "Fichiers téléversés.",
      "UPLOAD_ERROR": "Échec du téléversement.",
      "NO_ATTACHMENTS": "Aucune pièce jointe pour le moment.",
      "COL_NAME": "Fichier",
      "COL_TYPE": "Type",
      "COL_SIZE": "Taille",
      "COL_UPLOADED": "Téléversé",
      "COL_USER": "Utilisateur",
      "COL_ACTIONS": "Actions",
      "PREVIEW": "Aperçu",
      "DOWNLOAD": "Télécharger",
      "DELETE": "Supprimer",
      "DELETE_CONFIRM_TITLE": "Supprimer la pièce jointe",
      "DELETE_CONFIRM": "Supprimer <strong>{{name}}</strong> de ce rendez-vous ?",
      "DELETE_SUCCESS": "Pièce jointe supprimée.",
      "DELETE_ERROR": "Impossible de supprimer la pièce jointe.",
      "DOWNLOAD_ERROR": "Impossible de télécharger le fichier.",
      "PREVIEW_ERROR": "Impossible d'ouvrir l'aperçu du fichier.",
      "EXTRACTION_PENDING": "Extraction…",
      "EXTRACTION_COMPLETED": "Texte extrait",
      "EXTRACTION_SKIPPED": "Aperçu non disponible",
      "EXTRACTION_FAILED": "Échec de l'extraction",
      "BYTES": "{{size}} o",
      "KB": "{{size}} Ko",
      "MB": "{{size}} Mo",
      "FORMS": {
        "TITLE": "Formulaire du rendez-vous",
        "EMPTY": "Aucun formulaire pour ce rendez-vous.",
        "TYPE_REQUIRED": "Obligatoire",
        "TYPE_OPTIONAL": "Optionnel",
        "TYPE_UNKNOWN": "Type indisponible",
        "STATUS_SUBMITTED": "Soumis",
        "STATUS_PENDING": "Non soumis",
        "STATUS_EMPTY": "Indisponible",
        "PENDING_INFO": "Le client n'a pas encore rempli ce formulaire."
      }
    },
    "FIELDS_MANAGEMENT": {
      "TITLE": "Gérer les champs",
      "SUBTITLE": "Configurer les libellés de contact et les attributs personnalisés",
      "TAGS_TAB": "Tags et libellés",
      "ONBOARDING_TAB": "Onboarding chatbot",
      "CUSTOM_FIELDS_TAB": "Champs personnalisés",
      "TAG_INPUT_PLACEHOLDER": "Saisir le nom du nouveau tag…",
      "TAG_ALREADY_EXISTS": "Ce tag existe déjà",
      "TAG_CREATED": "Tag créé avec succès.",
      "LOADING_TAGS": "Chargement des tags…",
      "ERROR_LOADING_TAGS": "Erreur lors du chargement des tags",
      "ERROR_CREATING_TAG": "Erreur lors de la création du tag",
      "ERROR_DELETING_TAG": "Erreur lors de la suppression du tag",
      "DELETE_TAG_CONFIRM_TITLE": "Confirmer la suppression",
      "DELETE_TAG_CONFIRM_MESSAGE": "Voulez-vous vraiment supprimer ce tag ?\n<strong>{{name}}</strong>",
      "CREATE_FIELD": "Créer un nouveau champ personnalisé",
      "EDIT_FIELD": "Modifier le champ",
      "FIELD_NAME": "Nom du champ",
      "FIELD_NAME_PLACEHOLDER": "ex. Date de naissance",
      "SLUG_ID": "Slug (ID)",
      "SLUG_PLACEHOLDER": "ex. birthday",
      "FORMAT_TYPE": "Type de format",
      "TEXT": "Texte",
      "NUM": "Num",
      "DATE": "Date",
      "BOOL": "Bool",
      "ADD_CUSTOM_FIELD": "Ajouter un champ personnalisé",
      "UPDATE_FIELD": "Mettre à jour le champ",
      "LOADING_FIELDS": "Chargement des champs personnalisés…",
      "ERROR_LOADING_FIELDS": "Erreur lors du chargement des champs personnalisés",
      "ERROR_CREATING_FIELD": "Erreur lors de la création du champ personnalisé",
      "ERROR_UPDATING_FIELD": "Erreur lors de la mise à jour du champ personnalisé",
      "ERROR_DELETING_FIELD": "Erreur lors de la suppression du champ personnalisé",
      "DELETE_FIELD_CONFIRM_TITLE": "Confirmer la suppression",
      "DELETE_FIELD_CONFIRM_MESSAGE": "Voulez-vous vraiment supprimer ce champ personnalisé ?\n<strong>{{name}}</strong>",
      "QUESTION_EXAMPLE": "Question / Exemple",
      "QUESTION_EXAMPLE_PLACEHOLDER": "ex. Quelle est votre date de naissance ?",
      "ACTIVE": "Actif",
      "REQUIRED": "Obligatoire",
      "REQUIRED_FOR_ONBOARDING": "Obligatoire pour l'onboarding chatbot",
      "ONBOARDING_HINT": "Si vous activez « Obligatoire pour l'onboarding chatbot », le chatbot demandera ce champ avant de continuer. La question utilisée est celle de « Question / Exemple ».",
      "ONBOARDING_QUESTION": "Question d'onboarding",
      "ONBOARDING_QUESTION_EMPTY": "Aucune question personnalisée définie",
      "ONBOARDING_TAB_SUBTITLE": "Gérez les informations de base demandées au début du chat : prénom, nom, téléphone et e-mail (l'e-mail est optionnel).",
      "EDIT_ONBOARDING_FIELD": "Modifier le champ d'onboarding",
      "FIELD_ENABLED": "Champ activé dans la collecte de données",
      "SAVE_ONBOARDING_FIELD": "Enregistrer le champ d'onboarding",
      "CLOSE_MANAGEMENT": "Fermer la gestion"
    },
    "FILTERS": {
      "ADVANCED_FILTERS": "Filtres avancés",
      "COMMUNICATION_PLATFORM": "Plateforme de communication",
      "CLIENT_LABELS": "Libellés client",
      "LAST_ACTIVE_PERIOD": "Période de dernière activité",
      "ALL_TIME": "Tout le temps",
      "LAST_7_DAYS": "7 derniers jours",
      "LAST_30_DAYS": "30 derniers jours",
      "RESET_ALL": "Tout réinitialiser",
      "APPLY": "Appliquer"
    }
  },

  "SERVICES": {
    "MANAGE_CATEGORIES": "Gérer les catégories",
    "ADD_SERVICE": "Ajouter un service",
    "SEARCH_PLACEHOLDER": "Rechercher des services par nom ou description…",
    "FILTER_BY": "Filtrer par :",
    "ALL": "Tous",
    "ACTIVE": "Actif",
    "INACTIVE": "Inactif",
    "FILTER_BY_CATEGORY": "Filtrer par catégorie",
    "CLEAR": "Effacer",
    "RESET_FILTERS": "Réinitialiser les filtres",
    "NO_SERVICES": "Aucun service trouvé",
    "PRICE": "Prix",
    "DURATION": "Durée",
    "PREP": "Préparation",
    "COOLDOWN": "Repos",
    "SHOWING": "Affichage",
    "OF": "sur",
    "SERVICES": "services",
    "DELETE_CONFIRM_TITLE": "Confirmer la suppression",
    "DELETE_CONFIRM": "Voulez-vous vraiment supprimer ce service ?\n<strong>{{name}}</strong>",
    "ERROR_LOADING": "Erreur lors du chargement des services",
    "ERROR_DELETING": "Erreur lors de la suppression du service",
    "FORMS": {
      "ADD_FORM": "Ajouter un formulaire",
      "MANAGE_FORMS": "Gérer les formulaires",
      "MANAGE_TITLE": "Gestion des formulaires",
      "MANAGE_SUBTITLE": "Voir, modifier ou supprimer les formulaires de réservation.",
      "NO_FORMS": "Vous n'avez pas encore créé de formulaire.",
      "TEST_FORM": "Tester le formulaire",
      "ADD_TITLE": "Créer un nouveau formulaire",
      "EDIT_TITLE": "Modifier le formulaire",
      "ADD_SUBTITLE": "Configurez la structure et les questions du nouveau formulaire.",
      "EDIT_SUBTITLE": "Mettre à jour le titre, la description et les questions du formulaire.",
      "METADATA_TITLE": "Paramètres du formulaire",
      "NAME": "Nom du formulaire",
      "NAME_PLACEHOLDER": "ex. Questionnaire pré-visite",
      "DESCRIPTION": "Description (optionnelle)",
      "DESCRIPTION_PLACEHOLDER": "Expliquez brièvement à quoi sert ce formulaire…",
      "QUESTIONS_TITLE": "Questions du formulaire",
      "ADD_QUESTION": "Ajouter une question",
      "QUESTION_TEXT": "Texte de la question",
      "QUESTION_TEXT_PLACEHOLDER": "ex. Avez-vous des allergies connues ?",
      "QUESTION_DESCRIPTION": "Description de la question (optionnelle)",
      "QUESTION_DESCRIPTION_PLACEHOLDER": "Ajoutez des détails ou des instructions pour cette question…",
      "QUESTION_TYPE": "Type de réponse",
      "QUESTION_REQUIRED": "Réponse obligatoire",
      "OPTIONS_TITLE": "Options de réponse",
      "ADD_OPTION": "Ajouter une option",
      "OPTION_LABEL": "Option",
      "OPTION_PLACEHOLDER": "ex. Oui",
      "TYPE_TEXT": "Réponse courte",
      "TYPE_MULTILINE": "Paragraphe",
      "TYPE_SINGLE_CHOICE": "Choix unique",
      "TYPE_MULTIPLE_CHOICE": "Choix multiple",
      "TYPE_NUMBER": "Nombre",
      "TYPE_DATE": "Date",
      "BOOKING_FORM_TITLE": "Formulaire de réservation",
      "SELECT_FORM": "Sélectionner un formulaire à associer",
      "NO_FORM": "Aucun formulaire",
      "REQUIRED_FOR_BOOKING": "Formulaire obligatoire pour confirmer la réservation",
      "PRIVACY_POLICY_ENABLE": "Activer le formulaire Confidentialité et politique",
      "PRIVACY_POLICY_TEXT_LABEL": "Texte Confidentialité et politique",
      "PRIVACY_POLICY_TEXT_PLACEHOLDER": "Saisir le texte complet de la politique de confidentialité",
      "PRIVACY_POLICY_LINK_LABEL": "Lien Confidentialité et politique",
      "PRIVACY_POLICY_LINK_PLACEHOLDER": "https://...",
      "SAVE": "Enregistrer le formulaire",
      "UPDATE": "Mettre à jour le formulaire",
      "ERROR_LOADING_FORMS": "Erreur lors du chargement des formulaires",
      "DELETE_CONFIRM_TITLE": "Supprimer le formulaire",
      "DELETE_CONFIRM": "Voulez-vous vraiment supprimer ce formulaire ?\n<strong>{{name}}</strong>",
      "ERROR_DELETING_FORM": "Erreur lors de la suppression du formulaire",
      "ERROR_CREATING_TEST_LINK": "Erreur lors de la création du lien de test pour ce formulaire",
      "TEST_LINK_OPENED": "Lien de test ouvert dans un nouvel onglet.",
      "ERROR_SAVING_FORM": "Erreur lors de l'enregistrement du formulaire",
      "ERROR_UPDATING_FORM": "Erreur lors de la mise à jour du formulaire"
    },
    "MODAL": {
      "ADD_TITLE": "Ajouter un nouveau service",
      "EDIT_TITLE": "Modifier le service",
      "ADD_SUBTITLE": "Créer un nouveau service pour votre catalogue.",
      "EDIT_SUBTITLE": "Mettre à jour les informations du service.",
      "DETAILS": "Détails du service",
      "NAME": "Nom du service",
      "NAME_PLACEHOLDER": "ex. Peeling chimique",
      "DESCRIPTION": "Description",
      "DESCRIPTION_PLACEHOLDER": "Décrivez le soin et ses bienfaits…",
      "CATEGORIES": "Catégories",
      "CATEGORIES_PLACEHOLDER": "Sélectionner des catégories…",
      "MORE_CATEGORIES": "de plus +",
      "PRICE_AND_DURATION": "Prix et durée",
      "PRICE": "Prix (€)",
      "PRICE_PLACEHOLDER": "ex. 120",
      "DURATION": "Durée (min)",
      "DURATION_PLACEHOLDER": "ex. 45",
      "PREP_TIME": "Temps de préparation (min)",
      "PREP_PLACEHOLDER": "0",
      "COOLDOWN_TIME": "Temps de repos (min)",
      "COOLDOWN_PLACEHOLDER": "0",
      "BUFFER_TIMES_TITLE": "Temps de buffer dynamiques",
      "BUFFER_TIMES_DESC": "Définissez le temps supplémentaire à bloquer automatiquement dans votre calendrier pour la préparation et les soins post-traitement.",
      "ACTIVE_STATUS_LABEL": "Statut actif",
      "ACTIVE_STATUS_DESCRIPTION": "Lorsqu'il est actif, ce service est disponible à la réservation.",
      "STATUS": "Statut",
      "CANCEL": "Annuler",
      "CREATE": "Créer le service",
      "UPDATE": "Mettre à jour le service",
      "ERROR_CREATING": "Erreur lors de la création du service",
      "ERROR_UPDATING": "Erreur lors de la mise à jour du service"
    },
    "CATEGORIES": {
      "TITLE": "Gérer les catégories de services",
      "SUBTITLE": "Créer et supprimer les catégories utilisées pour classer les services.",
      "INPUT_PLACEHOLDER": "Saisir le nom de la nouvelle catégorie…",
      "LOADING": "Chargement des catégories…",
      "ALREADY_EXISTS": "Cette catégorie existe déjà",
      "ERROR_LOADING": "Erreur lors du chargement des catégories",
      "ERROR_CREATING": "Erreur lors de la création de la catégorie",
      "ERROR_DELETING": "Erreur lors de la suppression de la catégorie",
      "DELETE_CONFIRM_TITLE": "Confirmer la suppression",
      "DELETE_CONFIRM_MESSAGE": "Voulez-vous vraiment supprimer cette catégorie ?\n<strong>{{name}}</strong>"
    }
  },

  "COLLABORATORS": {
    "ADD": "Ajouter un collaborateur",
    "SEARCH_PLACEHOLDER": "Rechercher des collaborateurs par nom ou service…",
    "FILTER_BY": "Filtrer par :",
    "FILTER_BY_SERVICES": "Filtrer par services assignés",
    "ALL": "Tous",
    "AVAILABLE": "Disponible",
    "NOT_AVAILABLE": "Non disponible",
    "SHOWING": "Affichage",
    "OF": "sur",
    "COLLABORATORS_COUNT": "collaborateurs",
    "NO_COLLABORATORS": "Aucun collaborateur trouvé",
    "NO_COLLABORATORS_DESC": "Essayez d'ajuster vos filtres ou votre recherche.",
    "DELETE_CONFIRM_TITLE": "Confirmer la suppression",
    "DELETE_CONFIRM": "Voulez-vous vraiment supprimer ce collaborateur ?\n<strong>{{name}}</strong>",
    "ERROR_LOADING": "Erreur lors du chargement des collaborateurs",
    "ERROR_DELETING": "Erreur lors de la suppression du collaborateur",
    "ERROR_SAVE": "Erreur lors de l'enregistrement du collaborateur",
    "MODAL": {
      "ADD_TITLE": "Ajouter un nouveau collaborateur",
      "EDIT_TITLE": "Modifier le collaborateur",
      "ADD_SUBTITLE": "Créer un nouveau collaborateur et définir son planning et ses services.",
      "EDIT_SUBTITLE": "Mettre à jour les détails, le planning et les services assignés du collaborateur.",
      "PROFILE": "Profil du collaborateur",
      "PROFILE_DESC": "Configurer les détails du personnel, les horaires et les services assignés.",
      "FIRST_NAME": "Prénom",
      "FIRST_NAME_PLACEHOLDER": "ex. Elena",
      "LAST_NAME": "Nom",
      "LAST_NAME_PLACEHOLDER": "ex. Rossi",
      "EMAIL": "Adresse e-mail",
      "EMAIL_PLACEHOLDER": "elena.rossi@company.com",
      "PHONE": "Numéro de téléphone",
      "PHONE_PLACEHOLDER": "+33 6 12 34 56 78",
      "ADDRESS": "Adresse",
      "ADDRESS_DESC": "Lieu où ce collaborateur travaille pour les services en présentiel.",
      "REMOTE": "À distance",
      "REMOTE_DESCRIPTION": "Lorsqu'activé, les services sont délivrés à distance (ex. appel vidéo) ; l'adresse ne s'applique pas.",
      "ADDRESS_STREET": "Rue",
      "ADDRESS_STREET_PLACEHOLDER": "ex. 10 rue de la République",
      "ADDRESS_CITY": "Ville",
      "ADDRESS_CITY_PLACEHOLDER": "ex. Paris",
      "ADDRESS_PROVINCE": "Département / Région",
      "ADDRESS_PROVINCE_PLACEHOLDER": "ex. 75",
      "ADDRESS_POSTAL_CODE": "Code postal",
      "ADDRESS_POSTAL_CODE_PLACEHOLDER": "ex. 75001",
      "ADDRESS_COUNTRY": "Pays",
      "ADDRESS_COUNTRY_PLACEHOLDER": "ex. France",
      "ASSIGNED_SERVICES": "Services assignés",
      "ASSIGNED_SERVICES_PLACEHOLDER": "Sélectionner les services à assigner…",
      "STATUS": "Statut de disponibilité",
      "STATUS_DESCRIPTION": "Lorsqu'il est disponible, ce collaborateur peut être assigné aux réservations.",
      "SAVE": "Enregistrer le collaborateur",
      "UPDATE": "Mettre à jour le collaborateur"
    },
    "WEEKDAYS": {
      "MONDAY": "Lundi",
      "TUESDAY": "Mardi",
      "WEDNESDAY": "Mercredi",
      "THURSDAY": "Jeudi",
      "FRIDAY": "Vendredi",
      "SATURDAY": "Samedi",
      "SUNDAY": "Dimanche"
    },
    "WORKING_HOURS": {
      "LABEL": "Horaires de travail",
      "DESC": "Définissez quand ce collaborateur est disponible pour les réservations.",
      "EDIT": "Modifier les horaires d'ouverture",
      "ADD": "Ajouter des horaires d'ouverture",
      "TITLE": "Définir les horaires de travail",
      "SUBTITLE": "Définir le planning hebdomadaire et les pauses.",
      "QUICK_APPLY": "Application rapide :",
      "EVERY_DAY": "Tous les jours",
      "WEEKDAYS": "Jours ouvrés (lun.–ven.)",
      "WEEKENDS": "Week-ends (sam.–dim.)",
      "ADD_RANGE": "Ajouter une plage",
      "CLOSED": "Fermé",
      "SAVE_HOURS": "Enregistrer les horaires",
      "INVALID_RANGE": "Plage invalide pour {{day}} : l'heure de début doit être avant l'heure de fin.",
      "OVERLAP": "Plages qui se chevauchent détectées pour {{day}}.",
      "DISCARD_CONFIRM": "Abandonner les modifications ?",
      "SUMMARY_MON_FRI": "Lun.–ven.",
      "SUMMARY_EVERY_DAY": "Tous les jours",
      "SUMMARY_DAYS": "{{count}} jours / semaine"
    }
  },

  "KNOWLEDGE_BASE": {
    "TITLE": "Base de connaissances",
    "TAB_FAQS": "FAQ",
    "TAB_LINKS": "Liens externes",
    "DELETE_FAQ_CONFIRM_TITLE": "Confirmer la suppression",
    "DELETE_FAQ_CONFIRM_MESSAGE": "Voulez-vous vraiment supprimer cette FAQ ?\n<strong>{{question}}</strong>",
    "DELETE_LINK_CONFIRM_TITLE": "Confirmer la suppression",
    "DELETE_LINK_CONFIRM_MESSAGE": "Voulez-vous vraiment supprimer ce lien ?\n<strong>{{title}}</strong>",
    "SEARCH_FAQS": "Rechercher dans les FAQ…",
    "SEARCH_LINKS": "Rechercher des liens…",
    "ADD_FAQ": "Ajouter une FAQ",
    "ADD_LINK": "Ajouter un lien",
    "EMPTY_FAQS_TITLE": "Aucune FAQ trouvée",
    "EMPTY_FAQS_DESC": "Aucune question ne correspond à votre recherche. Essayez d'en ajouter une ou d'ajuster vos mots-clés.",
    "EMPTY_LINKS_TITLE": "Aucun lien trouvé",
    "EMPTY_LINKS_DESC": "Commencez à construire votre base de connaissances en ajoutant des liens vers des ressources externes.",
    "MODAL": {
      "TITLE_ADD_FAQ": "Ajouter une nouvelle FAQ",
      "TITLE_EDIT_FAQ": "Modifier la FAQ",
      "TITLE_ADD_LINK": "Ajouter un nouveau lien",
      "TITLE_EDIT_LINK": "Modifier le lien",
      "FAQ_SUBTITLE": "Enseignez à l'IA une réponse métier spécifique.",
      "LINK_SUBTITLE": "Fournissez une ressource externe que l'IA pourra consulter.",
      "FAQ_DETAILS": "Détails de la FAQ",
      "LINK_INFO": "Informations du lien",
      "QUESTION": "Question",
      "QUESTION_PLACEHOLDER": "ex. Quels sont vos horaires d'ouverture ?",
      "ANSWER": "Réponse",
      "ANSWER_PLACEHOLDER": "Fournissez la réponse détaillée pour l'IA…",
      "TITLE": "Titre",
      "TITLE_PLACEHOLDER": "ex. PDF tarifs 2024",
      "URL": "URL",
      "URL_PLACEHOLDER": "https://example.com",
      "SHORT_DESCRIPTION": "Description courte",
      "SHORT_DESCRIPTION_PLACEHOLDER": "Expliquez à l'IA ce que contient ce lien…",
      "CANCEL": "Annuler",
      "SAVE_CHANGES": "Enregistrer les modifications",
      "ADD_FAQ": "Ajouter la FAQ",
      "ADD_LINK": "Ajouter le lien",
      "ERROR_SAVE": "Impossible d'enregistrer. Veuillez réessayer."
    },
    "ERROR_LOADING_FAQ": "Erreur lors du chargement des FAQ",
    "ERROR_LOADING_LINKS": "Erreur lors du chargement des liens",
    "ERROR_DELETE_FAQ": "Erreur lors de la suppression de la FAQ",
    "ERROR_DELETE_LINK": "Erreur lors de la suppression du lien"
  },

  "ERRORS": {
    "AUTH_INVALID_CREDENTIALS": "E-mail ou mot de passe invalide",
    "AUTH_TOKEN_EXPIRED": "Votre session a expiré, veuillez vous reconnecter",
    "AUTH_UNAUTHORIZED": "Vous n'êtes pas autorisé à accéder à cette ressource",
    "AUTH_EMAIL_ALREADY_EXISTS": "Un compte avec cet e-mail existe déjà",
    "AUTH_FORBIDDEN": "Vous n'avez pas la permission d'effectuer cette action",

    "TENANT_NOT_FOUND": "Tenant introuvable",
    "TENANT_ALREADY_EXISTS": "Un tenant avec ce nom existe déjà",
    "TENANT_NAME_TAKEN": "Ce nom de tenant est déjà pris",
    "TENANT_CREATION_FAILED": "Échec de la création du tenant",
    "TENANT_UPDATE_FORBIDDEN": "Seul un super admin peut mettre à jour les tenants",
    "TENANT_DELETE_FORBIDDEN": "Seul un super admin peut supprimer les tenants",
    "TENANT_ACCESS_DENIED": "Accès refusé à ce tenant",
    "TENANT_INVITE_FORBIDDEN": "Seul un super admin ou un admin du tenant peut inviter des utilisateurs",

    "USER_NOT_FOUND": "Utilisateur introuvable",
    "USER_EMAIL_INVALID": "Adresse e-mail invalide",
    "USER_ROLE_INVALID": "Rôle utilisateur invalide",
    "USER_UPDATE_FORBIDDEN": "Vous ne pouvez pas mettre à jour cet utilisateur",
    "USER_ASSIGN_FORBIDDEN": "Seul un super admin peut assigner des utilisateurs aux tenants",
    "USER_REMOVE_FORBIDDEN": "Seul un super admin peut retirer des utilisateurs des tenants",

    "INVITE_NOT_FOUND": "Invitation introuvable",
    "INVITE_EXPIRED": "Cette invitation a expiré",
    "INVITE_ALREADY_USED": "Cette invitation a déjà été utilisée",
    "INVITE_CREATION_FAILED": "Échec de la création de l'invitation",
    "INVITE_EMAIL_SEND_FAILED": "Échec de l'envoi de l'e-mail d'invitation. L'invitation a été annulée. Vérifiez votre clé API Resend, les IDs de modèles et la configuration de l'expéditeur.",

    "CONTACT_NOT_FOUND": "Contact introuvable",
    "CONTACT_ACCESS_DENIED": "Accès refusé à ce contact",
    "CONTACT_CREATION_FORBIDDEN": "Seuls admin ou super_admin peuvent créer des contacts",
    "CONTACT_UPDATE_FORBIDDEN": "Seuls admin ou super_admin peuvent mettre à jour des contacts",
    "CONTACT_DELETE_FORBIDDEN": "Seuls admin ou super_admin peuvent supprimer des contacts",
    "CONTACT_DUPLICATE_EMAIL": "Un contact avec cet e-mail existe déjà dans votre tenant",

    "VALIDATION_REQUIRED_FIELD": "Ce champ est obligatoire",
    "VALIDATION_INVALID_EMAIL": "Format d'e-mail invalide",
    "VALIDATION_MIN_LENGTH": "La valeur est trop courte",
    "VALIDATION_MAX_LENGTH": "La valeur est trop longue",

    "SYSTEM_INTERNAL_ERROR": "Une erreur inattendue s'est produite",
    "SYS_001": "Erreur inconnue",
    "SYSTEM_DATABASE_ERROR": "Échec de l'opération sur la base de données",
    "NETWORK_ERROR": "Erreur de connexion réseau"
  },

  "ERROR_MODAL": {
    "TITLE": "Erreur",
    "HEADING": "Une erreur s'est produite",
    "STATUS": "Statut",
    "ERROR_CODE": "Code d'erreur",
    "MESSAGE": "Message",
    "PATH": "Chemin",
    "TIMESTAMP": "Horodatage",
    "DETAILS": "Détails",
    "TECHNICAL_DETAILS": "Détails techniques",
    "NO_MESSAGE": "Aucun message",
    "CLOSE": "Fermer"
  },

  "SUCCESS": {
    "TENANT_CREATED": "Tenant créé avec succès",
    "TENANT_UPDATED": "Tenant mis à jour avec succès",
    "TENANT_DELETED": "Tenant supprimé avec succès",
    "USER_INVITED": "Invitation envoyée avec succès",
    "USER_UPDATED": "Utilisateur mis à jour avec succès",
    "USER_ASSIGNED": "Utilisateur assigné au tenant avec succès",
    "USER_REMOVED": "Utilisateur retiré du tenant avec succès",
    "INVITE_ACCEPTED": "Invitation acceptée avec succès"
  },

  "INVITE_ACCEPT": {
    "TITLE": "Accepter l'invitation",
    "SUBTITLE_LOADING": "Finalisation de l'inscription…",
    "SUBTITLE_VALID": "Complétez votre profil pour rejoindre le tenant",
    "SUBTITLE_INVALID": "Saisissez le lien d'invitation reçu par e-mail",
    "VALIDATING": "Validation de l'invitation…",
    "INVITED_BY": "Vous avez été invité par",
    "THIS_TENANT": "ce tenant",
    "EMAIL": "E-mail",
    "ROLE": "Rôle",
    "FIRST_NAME": "Prénom",
    "LAST_NAME": "Nom",
    "PASSWORD": "Mot de passe",
    "CONFIRM_PASSWORD": "Confirmer le mot de passe",
    "PHONE_OPTIONAL": "Téléphone (optionnel)",
    "PASSWORD_MISMATCH": "Les mots de passe ne correspondent pas.",
    "ACCEPTING": "Acceptation…",
    "ACCEPT_BUTTON": "Accepter l'invitation",
    "SUCCESS_REDIRECT": "Invitation acceptée avec succès ! Redirection vers le tableau de bord…",
    "BACK_TO_LOGIN": "Retour à la connexion",
    "INVALID_TOKEN": "Jeton d'invitation invalide",
    "INVITE_INVALID_OR_EXPIRED": "Invitation invalide ou expirée",
    "VALIDATION_ERROR": "Erreur lors de la validation de l'invitation",
    "ACCEPT_ERROR": "Erreur lors de l'acceptation de l'invitation",
    "ACCOUNT_CREATE_ERROR": "Erreur lors de la création du compte",
    "LOAD_USER_ERROR": "Compte créé mais nous n'avons pas pu charger votre profil. Veuillez essayer de vous connecter."
  },

  "FIREBASE_AUTH": {
    "EMAIL_ALREADY_IN_USE": "Cet e-mail est déjà utilisé",
    "WEAK_PASSWORD": "Le mot de passe doit contenir au moins 6 caractères",
    "INVALID_EMAIL": "Adresse e-mail invalide",
    "TOO_MANY_ATTEMPTS": "Trop de tentatives. Veuillez réessayer plus tard",
    "OPERATION_NOT_ALLOWED": "Cette méthode de connexion n'est pas activée",
    "USER_DISABLED": "Ce compte a été désactivé",
    "GENERIC": "Erreur d'authentification. Veuillez réessayer",
    "INVALID_CREDENTIAL": "E-mail ou mot de passe invalide",
    "NETWORK_ERROR": "Erreur réseau. Vérifiez votre connexion et réessayez",
    "POPUP_CLOSED": "La connexion a été annulée",
    "ACCOUNT_EXISTS_DIFFERENT_CREDENTIAL": "Un compte existe déjà avec le même e-mail mais une méthode de connexion différente",
    "REQUIRES_RECENT_LOGIN": "Veuillez vous déconnecter puis vous reconnecter pour continuer",
    "EXPIRED_ACTION_CODE": "Ce lien a expiré",
    "INVALID_ACTION_CODE": "Ce lien est invalide ou a déjà été utilisé",
    "EMAIL_CHANGE_NEEDS_VERIFICATION": "Veuillez vérifier votre nouvelle adresse e-mail",
    "UNKNOWN_ERROR": "Erreur inconnue. Veuillez réessayer"
  },
  "AGENDA": {
    "WEEKDAYS_SHORT": {
      "SUNDAY": "Dim",
      "MONDAY": "Lun",
      "TUESDAY": "Mar",
      "WEDNESDAY": "Mer",
      "THURSDAY": "Jeu",
      "FRIDAY": "Ven",
      "SATURDAY": "Sam"
    },
    "WEEKDAY_LETTERS": "L,M,M,J,V,S,D",
    "MONTHS": {
      "JANUARY": "Janvier",
      "FEBRUARY": "Février",
      "MARCH": "Mars",
      "APRIL": "Avril",
      "MAY": "Mai",
      "JUNE": "Juin",
      "JULY": "Juillet",
      "AUGUST": "Août",
      "SEPTEMBER": "Septembre",
      "OCTOBER": "Octobre",
      "NOVEMBER": "Novembre",
      "DECEMBER": "Décembre"
    },
    "NO_AVAILABLE_SLOTS": "Aucun créneau disponible",
    "SLOT_BOOKED": "Déjà réservé",
    "NEW_APPOINTMENT": "Nouveau rendez-vous",
    "SEARCH_PLACEHOLDER": "Rechercher par titre, client ou notes…",
    "FILTER_BY": "Filtrer par :",
    "ALL": "Tous",
    "CONFIRMED": "Confirmé",
    "PENDING": "En attente",
    "COMPLETED": "Terminé",
    "CANCELLED": "Annulé",
    "CANCELLED_BY_CLIENT": "Annulé par le client",
    "LIST": "Liste",
    "CALENDAR": "Calendrier",
    "TODAY": "Aujourd'hui",
    "VIEW_DAY": "Jour",
    "VIEW_WEEK": "Semaine",
    "VIEW_MONTH": "Mois",
    "ADVANCED_FILTERS": "Filtres avancés",
    "DATE_FROM": "Date de début",
    "DATE_TO": "Date de fin",
    "SERVICE": "Service",
    "CLIENT": "Client",
    "ALL_SERVICES": "Tous les services",
    "ALL_CLIENTS": "Tous les clients",
    "RESET_FILTERS": "Réinitialiser les filtres",
    "APPLY_FILTERS": "Appliquer les filtres",
    "NO_APPOINTMENTS": "Aucun rendez-vous ne correspond à ce filtre.",
    "EDIT": "Modifier",
    "COMPLETE": "Terminer",
    "NO_SHOW": "Absence",
    "CANCELLED_BY_CLIENT_LABEL": "Annulé par le client",
    "NO_SHOW_LABEL": "Absence",
    "NO_SHOW_CONFIRM_TITLE": "Marquer comme absence",
    "NO_SHOW_CONFIRM_MESSAGE": "Marquer ce rendez-vous comme absence ? Le client ne s'est pas présenté.",
    "NO_SHOW_CONFIRM_YES": "Marquer comme absence",
    "CANCEL": "Annuler",
    "CONFIRM": "Confirmer",
    "ERROR_LOADING": "Erreur lors du chargement des rendez-vous",
    "DELETE_CONFIRM_TITLE": "Supprimer le rendez-vous",
    "DELETE_CONFIRM_MESSAGE": "Voulez-vous vraiment supprimer ce rendez-vous ? Cette action est irréversible.",
    "DELETE_CONFIRM_YES": "Supprimer",
    "ERROR_UPDATE": "Erreur lors de la mise à jour du rendez-vous",
    "ERROR_SAVE": "Erreur lors de l'enregistrement du rendez-vous",
    "CANCEL_CONFIRM_TITLE": "Annuler le rendez-vous",
    "CANCEL_CONFIRM_MESSAGE": "Voulez-vous vraiment annuler ce rendez-vous ?",
    "CANCEL_CONFIRM_YES": "Oui, annuler",
    "MODAL": {
      "ADD_TITLE": "Nouveau rendez-vous",
      "EDIT_TITLE": "Modifier le rendez-vous",
      "ADD_SUBTITLE": "Planifier un nouveau rendez-vous",
      "EDIT_SUBTITLE": "Mettre à jour les détails du rendez-vous",
      "SERVICE": "Service",
      "SELECT_SERVICE": "Sélectionner un service",
      "SEARCH_SERVICE": "Rechercher un service…",
      "NO_SERVICES": "Aucun service trouvé",
      "TITLE": "Titre",
      "TITLE_PLACEHOLDER": "ex. Coupe & brushing",
      "CLIENT": "Client",
      "SELECT_CLIENT": "Sélectionner un client",
      "SEARCH_CLIENT": "Rechercher un client…",
      "NO_CLIENTS": "Aucun client trouvé",
      "COLLABORATOR": "Collaborateur (optionnel)",
      "SELECT_COLLABORATOR": "Sélectionner un collaborateur",
      "SEARCH_COLLABORATOR": "Rechercher un collaborateur…",
      "NO_COLLABORATORS": "Aucun collaborateur trouvé",
      "STATUS": "Statut",
      "DATE": "Date",
      "START_TIME": "Heure de début",
      "END_TIME": "Heure de fin",
      "NOTES": "Notes (optionnelles)",
      "NOTES_PLACEHOLDER": "Ajouter des notes internes…",
      "SAVE": "Enregistrer les modifications",
      "CREATE": "Créer le rendez-vous"
    },
    "STATUS": {
      "CONFIRMED": "Confirmé",
      "PENDING": "En attente",
      "COMPLETED": "Terminé",
      "CANCELLED": "Annulé",
      "CANCELLED_BY_CLIENT": "Annulé par le client",
      "NO_SHOW": "Absence"
    },
    "COMPLETED_LABEL": "Terminé",
    "FORMS": {
      "BOOKING_FORM": "Formulaire de réservation",
      "RESPONSES_TITLE": "Réponses au formulaire",
      "RESPONSES_SUBTITLE": "Voir les réponses soumises pour ce rendez-vous",
      "LINK_TITLE": "Lien public du formulaire",
      "COPY_LINK": "Copier le lien",
      "NO_SUBMISSION": "Aucun formulaire n'a encore été généré pour ce rendez-vous.",
      "STATUS_PENDING": "Formulaire pas encore complété",
      "STATUS_SUBMITTED": "Formulaire complété",
      "ANSWERS_TITLE": "Réponses soumises",
      "PRIVACY_TITLE": "Confidentialité et politique",
      "PRIVACY_ACCEPTED_AT": "Accepté le",
      "NO_ANSWER": "Aucune réponse fournie",
      "VIEW_RESPONSES": "Voir les réponses",
      "NO_FORM_FOR_APPOINTMENT": "Aucun formulaire de réservation n'est associé à ce rendez-vous.",
      "ERROR_LOADING_FORM": "Erreur lors du chargement du formulaire",
      "ERROR_LOADING_SUBMISSION": "Erreur lors du chargement de la soumission du formulaire",
      "ERROR_NO_APPOINTMENT": "Sélectionnez un rendez-vous avec un formulaire de réservation pour voir les réponses."
    }
  },

  "FORMS": {
    "PUBLIC": {
      "NOT_FOUND": "Le formulaire est introuvable ou le lien est invalide.",
      "ALREADY_SUBMITTED": "Vous avez déjà soumis ce formulaire. Merci !",
      "ANSWER_PLACEHOLDER": "Tapez votre réponse…",
      "SUBMIT": "Envoyer le formulaire",
      "NEXT": "Suivant",
      "BACK": "Retour",
      "STEP_1_LABEL": "Détails et demandes",
      "STEP_2_LABEL": "Choisir l'heure",
      "PRIVACY_STEP_LABEL": "Confidentialité et politique",
      "PRIVACY_ACCEPT_LABEL": "J'ai lu et j'accepte la Confidentialité et la politique",
      "SUBMITTED_ANSWERS": "Réponses soumises",
      "SUMMARY_TITLE": "Récapitulatif de votre demande",
      "YOUR_ANSWERS": "Vos réponses",
      "YOUR_BOOKING": "Votre réservation",
      "CANCEL_BOOKING": "Annuler la réservation",
      "BOOKING_CANCELLED_SUCCESS": "Réservation annulée avec succès",
      "BOOKING_CANCELLED_ERROR": "Impossible d'annuler la réservation",
      "BOOKING_DATE": "Date",
      "BOOKING_TIME": "Heure",
      "BOOKING_SERVICE": "Service",
      "BOOKING_WITH": "Avec",
      "BOOKING_DURATION": "Durée",
      "BOOKING_CONTEXT_TITLE": "Détails de la réservation",
      "BOOKING_CONTEXT_REGION": "Récapitulatif service et professionnel",
      "BOOKING_CONFIRM_TITLE": "Confirmer la réservation",
      "CALENDAR_LOADING": "Chargement des créneaux…",
      "BOOKING_SUCCESS_TITLE": "Réservation confirmée.",
      "BOOKING_SUCCESS_MESSAGE": "Vous pouvez fermer cette page. Un message récapitulatif a été envoyé dans le chat.",
      "PREFILLED_SLOT_NOTICE": "Créneau fixé par l'opérateur : {{date}} {{startTime}}–{{endTime}}",
      "BOOK_CTA": "Réserver",
      "CONFIRM_CTA": "Confirmer",
      "CONFIRMING": "Confirmation…",
      "BOOKING_NOTE_LABEL": "Notes (optionnelles)",
      "BOOKING_NOTE_PLACEHOLDER": "Ajouter des notes pour le rendez-vous",
      "DURATION_FMT_MINUTES": "{{m}} minutes",
      "DURATION_FMT_ONE_HOUR": "1 heure",
      "DURATION_FMT_HOURS": "{{h}} heures",
      "DURATION_FMT_ONE_HOUR_AND_MINUTES": "1 heure et {{m}} minutes",
      "DURATION_FMT_HOURS_AND_MINUTES": "{{h}} heures et {{m}} minutes",
      "ERROR_LOADING": "Erreur lors du chargement du formulaire",
      "ERROR_SUBMITTING": "Erreur lors de l'envoi du formulaire",
      "REQUIRED_FIELD": "Ce champ est obligatoire",
      "INVALID_TOKEN": "Ce lien de formulaire est invalide ou a expiré.",
      "SUBMIT_SUCCESS": "Merci ! Votre formulaire a été envoyé avec succès.",
      "ERROR_LOADING_SLOTS": "Impossible de charger les créneaux disponibles.",
      "ERROR_BOOKING": "Impossible de finaliser la réservation. Veuillez réessayer."
    }
  },

  "WIDGET_DEMO": {
    "TITLE": "Démo du widget de chat",
    "DESCRIPTION": "Ceci est une page d'exemple pour tester le widget de chat. Le widget apparaît en bas à droite.",
    "DEMO_PAGE_TITLE": "Page de démo",
    "DEMO_PAGE_DESCRIPTION": "Cette page simule un site web avec le widget intégré. Vous pouvez interagir avec le chatbot en cliquant sur l'icône en bas à droite.",
    "ERROR_NO_CODE": "Aucun code de widget disponible. Générez un code depuis Paramètres.",
    "ERROR_NOT_GENERATED": "Code du widget non généré. Générez un code depuis Paramètres.",
    "ERROR_LOADING": "Erreur lors du chargement du widget. Vérifiez que le fichier du widget est disponible.",
    "SUCCESS_LOADED": "Widget chargé avec succès !",
    "SUCCESS_MESSAGE": "Cliquez sur l'icône en bas à droite pour ouvrir le chat et tester le widget.",
    "LOADING": "Chargement du widget…",
    "HOW_TO_TEST": "Comment tester :",
    "STEP_1": "Cliquez sur l'icône du widget en bas à droite",
    "STEP_2": "La fenêtre de chat s'ouvrira",
    "STEP_3": "Écrivez un message pour tester la conversation",
    "STEP_4": "Vérifiez que les réponses du chatbot fonctionnent correctement",
    "NOTE": "Note : Ceci est une page de démo. Pour intégrer le widget sur votre site, copiez le snippet HTML depuis Paramètres → Intégrations.",
    "GO_TO_SETTINGS": "Aller aux paramètres"
  },

  "WIDGET_TEST": {
    "TITLE": "Test d'intégration du widget",
    "DESCRIPTION": "Saisissez un code de widget pour tester l'intégration du chatbot sur votre site.",
    "CONFIGURATION_TITLE": "Configuration du widget",
    "CONFIGURATION_DESCRIPTION": "Saisissez le code du widget pour le valider et charger le widget de test",
    "WIDGET_CODE_LABEL": "Code du widget",
    "WIDGET_CODE_PLACEHOLDER": "Saisir le code du widget (ex. ABC123XYZ)",
    "WIDGET_CODE_REQUIRED": "Le code du widget est requis",
    "LOADING": "Chargement…",
    "LOAD_WIDGET": "Charger le widget",
    "ERROR_PREFIX": "Erreur :",
    "VALID_WIDGET": "Widget valide !",
    "TENANT": "Tenant",
    "SNIPPET_TITLE": "Snippet HTML",
    "SNIPPET_DESCRIPTION": "Copiez ce snippet et collez-le dans votre site web pour intégrer le widget",
    "COPY_SNIPPET": "Copier le snippet",
    "HOW_TO_TITLE": "Comment utiliser le widget",
    "HOW_TO_STEP_1": "Générez ou obtenez votre code de widget depuis la section Paramètres",
    "HOW_TO_STEP_2": "Collez le snippet HTML dans la section <code>&lt;head&gt;</code> ou avant la fermeture de <code>&lt;/body&gt;</code> sur votre site",
    "HOW_TO_STEP_3": "Le widget apparaîtra automatiquement sous forme d'icône en bas à droite",
    "HOW_TO_STEP_4": "Les utilisateurs peuvent cliquer sur l'icône pour ouvrir le chat",
    "NOTE_PREFIX": "Note :",
    "NOTE_TEXT": "Le widget est chargé dynamiquement sur cette page pour les tests. Assurez-vous que l'URL JS du widget est accessible publiquement lors de l'intégration sur votre site.",
    "ERROR_SUSPENDED": "Ce widget a été suspendu.",
    "ERROR_BLOCKED": "Ce widget a été bloqué.",
    "ERROR_INVALID": "Code de widget invalide ou inconnu.",
    "ERROR_LOAD": "Impossible de charger le widget. Vérifiez le code et réessayez.",
    "ERROR_SCRIPT": "Impossible de charger le script du widget. Vérifiez que le fichier est disponible."
  },

  "WIDGET": {
    "CHAT_TITLE": "Chat",
    "INPUT_PLACEHOLDER": "Tapez votre message…",
    "SEND_BUTTON": "Envoyer",
    "CLOSE_BUTTON": "Fermer le chat",
    "OPEN_CHAT": "Ouvrir le chat",
    "TYPING": "Écrit…",
    "ERROR_SENDING": "Désolé, une erreur s'est produite. Veuillez réessayer.",
    "ERROR_VALIDATION": "Code de widget invalide ou tenant non actif"
  },

  "CONVERSATIONS": {
    "SEARCH_PLACEHOLDER": "Rechercher messages, clients ou tags…",
    "FILTER_BY": "Filtrer par :",
    "FILTERS": {
      "ALL": "Tous",
      "UNREAD": "Non lus",
      "PENDING": "En attente",
      "RESOLVED": "Résolus"
    },
    "CLIENT_PROFILE": {
      "TITLE": "Profil client",
      "SEE_CONTACT": "Voir le contact",
      "FULL_NAME": "Nom complet",
      "EMAIL_ADDRESS": "Adresse e-mail",
      "PHONE_NUMBER": "Numéro de téléphone",
      "TAGS": "Tags",
      "SELECT_CONVERSATION": "Sélectionnez une conversation pour voir les détails du client."
    },
    "AI_SUMMARY": {
      "TITLE": "Résumé IA de la conversation",
      "NO_SUMMARY": "Aucun résumé disponible pour cette conversation pour le moment."
    },
    "CHAT": {
      "SELECT_CONVERSATION": "Sélectionnez une conversation à gauche pour commencer à chatter.",
      "LAST_VISIT": "Dernière visite",
      "AI_MODE": "Mode IA",
      "AI_MODE_ACTIVE_NOTICE": "Le mode IA est actif. Le chatbot répondra automatiquement aux messages entrants.",
      "REPLY_PLACEHOLDER": "Tapez votre réponse… (Entrée pour envoyer, Maj+Entrée pour une nouvelle ligne)",
      "SENDING": "Envoi…"
    },
    "CHANNELS": {
      "TELEGRAM": "Telegram",
      "WHATSAPP": "WhatsApp",
      "WEBCHAT": "Chat web"
    },
    "ERROR_LOAD_LIST": "Impossible de charger les conversations.",
    "ERROR_LOAD_DETAILS": "Impossible de charger cette conversation.",
    "ERROR_SEND_MESSAGE": "Impossible d'envoyer le message.",
    "ERROR_AI_MODE": "Impossible de mettre à jour le mode IA."
  },
  "FLOWS": {
    "ADD_FLOW": "Ajouter un flux",
    "NO_FLOWS": "Aucun flux configuré pour le moment.",
    "UNNAMED": "Flux sans titre",
    "SHOWING": "Affichage",
    "FLOWS_LABEL": "flux",
    "ERROR_LOADING": "Impossible de charger les flux.",
    "ERROR_CREATE": "Impossible de créer le flux.",
    "ERROR_UPDATE": "Impossible de mettre à jour le flux.",
    "ERROR_DELETE": "Impossible de supprimer le flux.",
    "ERROR_STATUS": "Impossible de mettre à jour le statut du flux.",
    "ERROR_TEST": "Impossible d'envoyer le test.",
    "ERROR_LOADING_EXECUTIONS": "Impossible de charger les exécutions du flux.",
    "CREATED": "Flux créé avec succès.",
    "UPDATED": "Flux mis à jour avec succès.",
    "DELETED": "Flux supprimé avec succès.",
    "DELETE_CONFIRM_TITLE": "Supprimer le flux",
    "DELETE_CONFIRM": "Voulez-vous vraiment supprimer ce flux ?\n<strong>{{name}}</strong>",
    "STATUS_UPDATED": "Statut du flux mis à jour.",
    "TEST_SENT": "Messages de test envoyés avec succès.",
    "COLUMNS": {
      "NAME": "Nom",
      "TRIGGER": "Déclencheur",
      "TIMING": "Timing",
      "STATUS": "Statut"
    },
    "TRIGGERS": {
      "APPOINTMENT_REQUESTED": "Rendez-vous demandé",
      "APPOINTMENT_CONFIRMED": "Rendez-vous confirmé",
      "APPOINTMENT_UPDATED": "Rendez-vous mis à jour",
      "APPOINTMENT_CANCELLED": "Rendez-vous annulé",
      "APPOINTMENT_CANCELLED_BY_CLIENT": "Rendez-vous annulé par le client",
      "APPOINTMENT_COMPLETED": "Rendez-vous terminé",
      "APPOINTMENT_NO_SHOW": "Absence au rendez-vous",
      "APPOINTMENT_REMINDER": "Rappel de rendez-vous (créneau)",
      "CONVERSATION_NO_RESPONSE": "Pas de réponse après un message sortant",
      "FORM_NOT_COMPLETED": "Formulaire laissé incomplet"
    },
    "TIMING": {
      "BEFORE": "Avant",
      "AFTER": "Après"
    },
    "UNITS": {
      "MINUTES": "minutes",
      "HOURS": "heures",
      "DAYS": "jours"
    },
    "STATUS": {
      "ACTIVE": "Actif",
      "PAUSED": "En pause",
      "AUTO_DISABLED": "Désactivé automatiquement"
    },
    "EXECUTION_STATUS": {
      "PENDING": "En attente",
      "PROCESSING": "En cours",
      "SENT": "Terminé",
      "FAILED": "Échoué",
      "CANCELLED": "Annulé"
    },
    "TABS": {
      "DEFINITIONS": "Flux",
      "EXECUTIONS": "Exécutions"
    },
    "EXECUTIONS": {
      "NO_EXECUTIONS": "Aucune exécution trouvée.",
      "FILTER_ALL": "Toutes",
      "OPEN_DETAILS": "Ouvrir les détails",
      "DETAILS_TITLE": "Détails de l'exécution du flux",
      "COLUMNS": {
        "FLOW": "Flux",
        "SCHEDULED_AT": "Planifié pour",
        "RUN_AT": "Exécuté à",
        "RETRIES": "Tentatives",
        "TARGET": "Cible",
        "ERROR": "Erreur"
      }
    },
    "CHANNEL": {
      "AUTO": "Préférence client"
    },
    "MODAL": {
      "ADD_TITLE": "Créer un flux",
      "EDIT_TITLE": "Modifier le flux",
      "SUBTITLE": "Configurez un message automatisé pour vos clients.",
      "GENERAL": "Général",
      "TITLE": "Titre",
      "TITLE_PLACEHOLDER": "ex. Rappel de rendez-vous après 24 h",
      "DESCRIPTION": "Description",
      "DESCRIPTION_PLACEHOLDER": "Notes internes (optionnel)",
      "TRIGGER": "Événement déclencheur",
      "TRIGGER_PLACEHOLDER": "Sélectionner un ou plusieurs déclencheurs…",
      "TIMING": "Timing",
      "BEFORE_AFTER": "Avant / Après",
      "NUMBER": "Nombre",
      "TIME_UNIT": "Unité",
      "MESSAGE": "Message",
      "MESSAGE_TEMPLATE": "Message de référence",
      "MESSAGE_PLACEHOLDER": "Bonjour {name}, votre rendez-vous est le {date} à {start_time}.",
      "PLACEHOLDER_SELECT_LABEL": "Insérer un placeholder",
      "ADD_PLACEHOLDER": "Ajouter",
      "PLACEHOLDERS_HINT": "Placeholders : {name}, {last_name}, {full_name}, {date}, {start_time}, {end_time}, {treatment}, {phone}, {mail}, {form_link}, {form_name}, {conversation_link}, {conversation_id}",
      "CHANNEL": "Canal de diffusion",
      "CHANNEL_OVERRIDE": "Canal",
      "CREATE": "Créer",
      "SAVE": "Enregistrer"
    },
    "TEST": {
      "TITLE": "Envoyer un test",
      "SUBTITLE": "Envoyer immédiatement un message de test aux membres de l'équipe sélectionnés.",
      "SELECT_RECIPIENTS": "Sélectionner les destinataires…",
      "SEND": "Envoyer le test"
    }
  },
  "FLOOR_PLAN": {
    "ROOMS": "Salles",
    "ROOM_DRAG_HANDLE_ARIA": "Glisser pour réordonner la salle",
    "ERROR_REORDER_ROOMS": "Impossible d'enregistrer l'ordre des salles.",
    "ROOM_BLOCK": "Bloquer la salle",
    "ROOM_BLOCK_CONFIRM_TITLE": "Bloquer cette salle ?",
    "ROOM_BLOCK_CONFIRM_MESSAGE": "La salle «{{name}}» n'acceptera pas de réservations ni de déplacements tant qu'elle est bloquée. Les tables et combinaisons restent visibles mais désactivées.",
    "ROOM_UNBLOCK": "Débloquer la salle",
    "ROOM_UNBLOCK_CONFIRM_TITLE": "Réactiver cette salle ?",
    "ROOM_UNBLOCK_CONFIRM_MESSAGE": "La salle «{{name}}» sera à nouveau disponible pour les réservations et les déplacements.",
    "ROOM_BLOCKED_BADGE": "Bloquée",
    "ROOM_BLOCKED_HINT": "Cette salle est bloquée : pas de réservations ni de déplacements vers cette salle. Les tables et combinaisons restent visibles mais sont désactivées.",
    "ROOM_BLOCKED_TOAST": "Salle bloquée.",
    "ROOM_UNBLOCKED_TOAST": "Salle débloquée.",
    "ERROR_TOGGLE_ROOM_BLOCK": "Impossible de mettre à jour le statut de blocage de la salle.",
    "ROOM_NAME": "Nom de la salle",
    "ROOM_DESCRIPTION": "Description",
    "ROOM_COLOR": "Couleur de la salle",
    "ADD_ROOM_TITLE": "Créer une salle",
    "EDIT_ROOM_TITLE": "Modifier la salle",
    "SAVE_ROOM": "Enregistrer la salle",
    "ADD_SECTION": "Ajouter",
    "ADD_PANEL_TITLE": "Ajouter à cette salle",
    "ADD_PANEL_TABLE": "Table",
    "ADD_PANEL_COMPONENT": "Composant de plan",
    "ADD_TABLE_BLOCK": "Ajouter une table",
    "ADD_NEW_TABLE": "Ajouter une nouvelle table",
    "EDIT_TABLE_TITLE": "Modifier la table",
    "SAVE_TABLE": "Enregistrer la table",
    "ADD_COMPONENT_BLOCK": "Ajouter un composant",
    "ADD_COMPONENT": "Ajouter un composant",
    "ADD_NEW_COMPONENT": "Ajouter un nouveau composant",
    "EDIT_COMPONENT_TITLE": "Modifier le composant",
    "SAVE_COMPONENT": "Enregistrer le composant",
    "COMPONENT_NAME": "Nom",
    "COMPONENT_NAME_PLACEHOLDER": "ex. Entrée principale, Porte cuisine",
    "COMPONENT_TYPE": "Type",
    "COMPONENT_COLOR": "Couleur",
    "CREATE_COMPONENT": "Créer",
    "COMPONENT_CREATED": "Composant créé avec succès.",
    "COMPONENT_UPDATED": "Composant mis à jour avec succès.",
    "COMPONENT_DELETED": "Composant supprimé avec succès.",
    "COMPONENT_TYPE_DOOR": "Porte",
    "COMPONENT_TYPE_WINDOW": "Fenêtre",
    "COMPONENT_TYPE_BATHROOM": "Toilettes",
    "COMPONENT_TYPE_KITCHEN": "Cuisine",
    "COMPONENT_TYPE_BAR": "Bar",
    "COMPONENT_TYPE_STAIRS": "Escalier",
    "COMPONENT_TYPE_PILLAR": "Pilier",
    "COMPONENT_TYPE_GENERIC": "Générique",
    "ADD_ROOM": "Ajouter une salle",
    "NO_ROOMS": "Aucune salle pour le moment",
    "TABLES": "tables",
    "SEATS": "places",
    "EDIT_LAYOUT": "Modifier le plan",
    "VIEW_MODE": "Mode affichage",
    "SEARCH_TABLE": "Rechercher une table",
    "FILTER_ALL": "Tous les statuts",
    "RESET_VIEW": "Réinitialiser la vue",
    "ZOOM_IN": "Zoom avant",
    "ZOOM_OUT": "Zoom arrière",
    "ZOOM_LEVEL": "Zoom : {{pct}} % (vous pouvez aussi utiliser la molette sur le canevas)",
    "TABLE_NAME": "Nom de la table",
    "LAYOUT_TOOLS": "Outils de plan",
    "TABLE_NAME_LABEL": "Nom de la table",
    "TABLE_NAME_PLACEHOLDER": "ex. Table 12",
    "TABLE_NUMBER": "Numéro de table",
    "TABLE_NUMBER_PLACEHOLDER": "ex. 1, A1, VIP-1",
    "TABLE_DISPLAY_NAME": "Nom d'affichage",
    "TABLE_DISPLAY_NAME_PLACEHOLDER": "Affiché en grand sur le plan de salle",
    "TABLE_CODE_AUTO_HINT": "Un code unique (ex. T-001) est attribué automatiquement à la création de la table. Il ne peut pas être modifié.",
    "TABLE_CODE_LABEL": "Code",
    "TABLE_COLOR": "Couleur de la table",
    "TABLE_SEATS_LABEL": "Places (nombre)",
    "MIN_SEATS": "Places min.",
    "MIN_SEATS_INVALID": "Le nombre minimum de places ne peut pas être supérieur au nombre de places.",
    "TABLE_SHAPE_LABEL": "Forme de la table",
    "ADD_TABLE": "Ajouter une table",
    "DECORATIONS_TITLE": "Décorations (bientôt)",
    "DECORATIONS_HINT": "Plantes, murs et colonnes seront disponibles dans cette section.",
    "SHAPE_ROUND": "Ronde",
    "SHAPE_SQUARE": "Carrée",
    "SHAPE_RECTANGLE": "Rectangle",
    "SHAPE_RECTANGLE_SHORT": "Rect.",
    "NO_TABLES": "Aucune table dans cette salle",
    "NO_TABLES_MATCH_SEARCH": "Aucune table ne correspond à votre recherche.",
    "CREATE_COMBINATION": "Créer une combinaison",
    "STATUS_FREE": "Libre",
    "STATUS_RESERVED": "Réservée",
    "STATUS_OCCUPIED": "Occupée",
    "STATUS_BLOCKED": "Bloquée",
    "ROOM_CREATED": "Salle créée avec succès.",
    "ROOM_DELETED": "Salle supprimée avec succès.",
    "TABLE_CREATED": "Table créée avec succès.",
    "TABLE_UPDATED": "Table mise à jour avec succès.",
    "TABLE_DELETED": "Table supprimée avec succès.",
    "DELETE_TABLE_CONFIRM_TITLE": "Supprimer la table",
    "DELETE_TABLE_CONFIRM_MESSAGE": "Voulez-vous vraiment supprimer la table {{name}} ?",
    "COMBINATION_CREATED": "Combinaison créée avec succès.",
    "COMBINATION_DELETED": "Combinaison supprimée avec succès.",
    "ERROR_LOAD_ROOMS": "Impossible de charger les salles.",
    "ERROR_CREATE_ROOM": "Impossible de créer la salle.",
    "ERROR_UPDATE_ROOM": "Impossible de mettre à jour la salle.",
    "ERROR_DELETE_ROOM": "Impossible de supprimer la salle.",
    "ERROR_LOAD_TABLES": "Impossible de charger les tables.",
    "ERROR_LOAD_COMBINATIONS": "Impossible de charger les combinaisons de tables.",
    "ERROR_LOAD_ROOM_LAYOUT": "Impossible de charger le plan de la salle (tables, combinaisons ou composants).",
    "ERROR_CREATE_COMPONENT": "Impossible de créer le composant de plan.",
    "ERROR_UPDATE_COMPONENT": "Impossible de mettre à jour le composant de plan.",
    "ERROR_DELETE_COMPONENT": "Impossible de supprimer le composant de plan.",
    "ERROR_CREATE_TABLE": "Impossible de créer la table.",
    "ERROR_UPDATE_TABLE": "Impossible de mettre à jour la table.",
    "ERROR_DELETE_TABLE": "Impossible de supprimer la table.",
    "ERROR_CREATE_COMBINATION": "Impossible de créer la combinaison.",
    "COMBINATIONS_TITLE": "Combinaisons de tables",
    "COMBINATIONS_EMPTY": "Aucune combinaison dans cette salle. En mode édition, utilisez Ctrl+clic (⌘ sur Mac) sur les tables pour les sélectionner, puis ajoutez une combinaison.",
    "COMBINATION_NEW_TITLE": "Nouvelle combinaison",
    "COMBINATION_EDIT_TITLE": "Modifier la combinaison",
    "COMBINATION_NAME": "Nom de la combinaison",
    "COMBINATION_NAME_PLACEHOLDER": "ex. Banquet A, Grand groupe",
    "COMBINATION_DISPLAY_NAME": "Nom d'affichage",
    "COMBINATION_DISPLAY_NAME_PLACEHOLDER": "Affiché dans les listes et lors de la mise en évidence sur le plan",
    "COMBINATION_CODE_AUTO_HINT": "Un code unique (ex. C-001) est attribué automatiquement à la création de la combinaison. Il ne peut pas être modifié.",
    "COMBINATION_CODE_LABEL": "Code",
    "COMBINATION_COLOR": "Couleur de la combinaison",
    "COMBINATION_MIN_PARTY": "Convives min. (taille du groupe)",
    "COMBINATION_MAX_PARTY": "Convives max. (taille du groupe)",
    "COMBINATION_PARTY_HINT": "Taille de groupe réservable pour cette combinaison — non liée à la somme des places des tables. Valeurs autorisées : 1–99 chacune.",
    "COMBINATION_BOOKABLE_RANGE": "Réservations {{min}}–{{max}} convives",
    "COMBINATION_PARTY_MIN_MAX_INVALID": "Le nombre minimum de convives ne peut pas être supérieur au maximum.",
    "COMBINATION_PARTY_BOUNDS_INVALID": "Le min. et le max. de convives doivent être entre 1 et 99.",
    "COMBINATION_PARTY_CAPACITY_INVALID": "La plage de convives doit être entre 1 et {{cap}} (places totales des tables sélectionnées).",
    "ERROR_COMBINATION_PARTY_MIN": "Le nombre minimum de convives doit être entre 1 et 99.",
    "ERROR_COMBINATION_PARTY_MAX": "Le nombre maximum de convives doit être entre 1 et 99.",
    "ERROR_COMBINATION_PARTY_CAPACITY": "La plage de convives ne peut pas dépasser le total des places de la combinaison.",
    "ERROR_COMBINATION_PARTY_MAX_BOUND": "Le min. et le max. de convives doivent être au plus 99.",
    "ERROR_COMBINATION_MIN_SEATS": "La combinaison doit avoir au moins 2 places au total.",
    "COMBINATION_TABLES_PICK": "Tables de cette salle",
    "COMBINATION_TOTAL_SEATS_PREVIEW": "Places totales (aperçu)",
    "COMBINATION_USE_CANVAS_SELECTION": "Utiliser la sélection actuelle du canevas",
    "COMBINATION_USE_CANVAS_SELECTION_EDIT_MODE": "Activez « Modifier le plan » pour multi-sélectionner des tables sur le plan (Ctrl+clic, ⌘ sur Mac), puis utilisez ce bouton.",
    "COMBINATION_NEED_TWO_TABLES": "Sélectionnez au moins deux tables.",
    "COMBINATION_NON_COMBINABLE_NOTE": "Non combinable — activez sur la fiche de la table.",
    "COMBINATION_SAVE": "Enregistrer la combinaison",
    "COMBINATION_UPDATED": "Combinaison mise à jour avec succès.",
    "TABLE_COMBINABLE": "Table combinable",
    "TABLE_COMBINABLE_HINT": "Seules les tables combinables peuvent être regroupées dans une combinaison nommée pour les réservations.",
    "DELETE_COMBINATION_CONFIRM_TITLE": "Supprimer la combinaison",
    "DELETE_COMBINATION_CONFIRM_MESSAGE": "Supprimer la combinaison {{name}} ? Les tables restent dans la salle.",
    "MULTI_SELECT_HINT": "En mode édition : Ctrl+clic (⌘ sur Mac) sur une table pour l'ajouter ou la retirer de la sélection du canevas. Utile pour créer des combinaisons.",
    "MULTI_SELECT_HINT_SHORT": "Ctrl+clic (⌘) table : multi-sélection",
    "COMBINATION_BADGE_TOOLTIP": "Dans {{count}} combinaison(s)",
    "COMBINATION_HIGHLIGHT_ON_PLAN": "Mettre en évidence ces tables sur le plan (cliquer à nouveau pour effacer)",
    "ERROR_COMBINATION_DUPLICATE_NAME": "Une combinaison avec ce nom existe déjà dans cette salle.",
    "ERROR_COMBINATION_MIN_TABLES": "Une combinaison doit inclure au moins deux tables distinctes.",
    "ERROR_COMBINATION_INVALID_TABLES": "Certaines tables sont invalides ou appartiennent à une autre salle.",
    "ERROR_COMBINATION_NOT_COMBINABLE": "Une ou plusieurs tables ne sont pas combinables.",
    "ERROR_COMBINATION_BOOKINGS": "Cette action est bloquée car des réservations futures sont liées à cette salle ou table.",
    "RESIZE_TABLE": "Redimensionner la table",
    "RESIZE_COMPONENT": "Redimensionner le composant",
    "SNAP_GRID_ON": "Alignement grille : activé",
    "SNAP_GRID_OFF": "Alignement grille : désactivé",
    "NO_CLIP_ON": "Sans clip : activé — tables et composants peuvent se chevaucher (limites du canevas toujours appliquées). Désactivez une fois le redesign terminé.",
    "NO_CLIP_OFF": "Sans clip : désactivé — espacement uniquement entre les tables ; les composants de plan peuvent se chevaucher entre eux et avec les tables.",
    "ADVANCED": "Avancé",
    "ADVANCED_ARIA": "Options avancées du plan",
    "ADVANCED_SNAP": "Aligner sur la grille",
    "ADVANCED_NO_CLIP": "Sans clip",
    "CANVAS_SHRINK_WIDTH": "Réduire la largeur du canevas",
    "CANVAS_GROW_WIDTH": "Augmenter la largeur du canevas",
    "CANVAS_SHRINK_HEIGHT": "Réduire la hauteur du canevas",
    "CANVAS_GROW_HEIGHT": "Augmenter la hauteur du canevas",
    "CANVAS_WIDTH": "Largeur du canevas",
    "CANVAS_HEIGHT": "Hauteur du canevas",
    "LIVE_TITLE": "Salle (en direct)",
    "LIVE_SUBTITLE": "Plan en direct — appuyez sur une table pour ajouter des réservations, marquer les clients installés ou bloquer la table. Les couleurs suivent les réservations et l'heure actuelle.",
    "LIVE_TAB_FLOOR": "Plan de salle",
    "LIVE_TAB_LIST": "Liste des réservations",
    "LIVE_TAB_ELENCO": "Par table",
    "LIVE_VIEW_TABS_ARIA": "Choisir la vue en direct : plan de salle ou liste",
    "LIVE_ACTIONS_ARIA": "Actions de réservation : réservation auto et recherche de toutes les réservations",
    "LIVE_LIST_HEADING": "Réservations",
    "LIVE_LIST_HINT": "Appuyez sur une ligne pour ouvrir la table et gérer la réservation. Changez la date dans la barre latérale.",
    "LIVE_LIST_EMPTY_ROOM": "Aucune réservation pour cette salle à la date sélectionnée.",
    "LIVE_LIST_TIMELINE_LEGEND": "Créneau dans la journée ({{start}}–{{end}})",
    "LIVE_LIST_ROW_ARIA": "{{start}} à {{end}}, {{title}}, {{place}}{{codePart}}. Ouvrir la table.",
    "LIVE_LIST_PLACEMENT_TABLE": "Table {{name}}",
    "LIVE_LIST_PLACEMENT_COMBO": "Combinaison {{name}}",
    "LIVE_LIST_TABLE_CAPTION": "Table",
    "LIVE_LIST_TABLE_COMBO_DETAIL": "{{combo}} — {{tables}}",
    "LIVE_LIST_TABLE_UNSPECIFIED": "Non assignée",
    "LIVE_LIST_PLACEMENT_UNSPEC": "Emplacement non défini",
    "LIVE_LIST_OPEN_ERROR": "Aucune table n'a pu être ouverte pour cette réservation.",
    "LIVE_BOOKING_CODE": "Code de réservation",
    "LIVE_SEARCH_LABEL": "Recherche",
    "LIVE_SEARCH_PLACEHOLDER": "Table, combo, code de réservation, titre ou client…",
    "LIVE_SEARCH_CLEAR": "Effacer la recherche",
    "LIVE_LIST_SEARCH_EMPTY": "Aucune réservation ne correspond à votre recherche. Essayez une autre table, un autre client ou un autre code.",
    "LIVE_FLOOR_SEARCH_EMPTY": "Aucune table de cette salle ne correspond à votre recherche. Effacez la recherche ou essayez un autre nom ou code de réservation.",
    "LIVE_DATE": "Date",
    "LIVE_REFRESH": "Actualiser",
    "LIVE_ROOM_LAYOUT_LOADING": "Chargement du plan de la salle…",
    "LIVE_TABLE_SHEET_TITLE": "Table {{name}}",
    "LIVE_ADD_RESERVATION": "Ajouter une réservation",
    "LIVE_ADD_WALKIN": "Ajouter un walk-in / installé",
    "LIVE_RESERVE_TABLE": "Réserver",
    "LIVE_AUTO_RES_OPEN": "Réservation auto",
    "LIVE_AUTO_RES_TITLE": "Réservation automatique",
    "LIVE_AUTO_RES_HINT": "Saisissez les détails et trouvez la meilleure table disponible dans les salles sélectionnées.",
    "LIVE_AUTO_RES_DATE": "Date de réservation",
    "LIVE_AUTO_RES_DATE_INVALID": "Choisissez une date de réservation valide.",
    "LIVE_AUTO_RES_ROOMS": "Salles à rechercher",
    "LIVE_AUTO_RES_ROOMS_PLACEHOLDER": "Sélectionner des salles",
    "LIVE_AUTO_RES_ROOMS_REQUIRED": "Sélectionnez au moins une salle.",
    "LIVE_AUTO_RES_FIND": "Trouver une table",
    "LIVE_AUTO_RES_FOUND": "Table suggérée",
    "LIVE_AUTO_RES_FOUND_TABLE": "Table : {{table}}",
    "LIVE_AUTO_RES_FOUND_COMBO": "Combinaison de tables : {{name}}",
    "LIVE_AUTO_RES_FOUND_COMBO_TABLES": "Tables : {{tables}}",
    "LIVE_AUTO_RES_FOUND_ROOM": "Salle : {{room}}",
    "LIVE_AUTO_RES_FOUND_TIME": "Heure : {{start}}-{{end}}",
    "LIVE_AUTO_RES_CONFIRM": "Confirmer la réservation",
    "LIVE_AUTO_RES_FIND_ANOTHER": "Trouver une autre table",
    "LIVE_AUTO_RES_NO_TABLE": "Aucune table disponible pour ces filtres.",
    "LIVE_AUTO_RES_NO_MORE_TABLES": "Plus d'autres tables alternatives disponibles.",
    "LIVE_AUTO_RES_LOOKUP_ERROR": "Impossible de rechercher les tables disponibles.",
    "LIVE_AUTO_RES_SUMMARY_TITLE": "Réservation confirmée",
    "LIVE_AUTO_RES_SUMMARY_TABLE": "Table : {{table}}",
    "LIVE_AUTO_RES_SUMMARY_COMBO": "Combinaison : {{name}}",
    "LIVE_AUTO_RES_SUMMARY_COMBO_TABLES": "Tables : {{tables}}",
    "LIVE_AUTO_RES_SUMMARY_ROOM": "Salle : {{room}}",
    "LIVE_AUTO_RES_SUMMARY_TIME": "Heure : {{start}}-{{end}}",
    "LIVE_AUTO_RES_SUMMARY_GUEST": "Client : {{guest}}",
    "LIVE_GLOBAL_RES_OPEN": "Rechercher des réservations",
    "LIVE_GLOBAL_RES_TITLE": "Recherche de réservations",
    "LIVE_GLOBAL_RES_HINT": "Recherchez par code de réservation, nom du client, ou nom de table/combinaison. Inclut toutes les dates et statuts (clôturées et installées).",
    "LIVE_GLOBAL_RES_FIELD_LABEL": "Texte de recherche",
    "LIVE_GLOBAL_RES_PLACEHOLDER": "Code, nom du client, table…",
    "LIVE_GLOBAL_RES_SEARCH": "Rechercher",
    "LIVE_GLOBAL_RES_OPEN_HINT": "Appuyez pour ouvrir la table à la date de cette réservation.",
    "LIVE_GLOBAL_RES_EMPTY": "Aucune réservation trouvée.",
    "LIVE_GLOBAL_RES_INITIAL": "Saisissez au moins 2 caractères et appuyez sur Rechercher.",
    "LIVE_GLOBAL_RES_QUERY_SHORT": "Saisissez au moins 2 caractères.",
    "LIVE_GLOBAL_RES_ERROR": "Échec de la recherche. Veuillez réessayer.",
    "LIVE_GLOBAL_RES_OPEN_NO_TABLE": "Impossible d'ouvrir : aucune table liée à cette réservation.",
    "LIVE_BLOCK_TABLE": "Bloquer la table",
    "LIVE_UNBLOCK_TABLE": "Débloquer la table",
    "LIVE_RELEASE_DAY": "Effacer toutes les réservations (journée)",
    "LIVE_MARK_SEATED": "Client arrivé",
    "LIVE_MARK_SEATED_SUCCESS": "Marqué comme installé.",
    "LIVE_MARK_SEATED_ERROR": "Impossible de mettre à jour l'installation.",
    "LIVE_RELEASE_TABLE_EARLY": "Libérer la table — les clients sont partis avant la fin de la réservation",
    "LIVE_RELEASE_TABLE_EARLY_TITLE": "Libérer la table",
    "LIVE_RELEASE_TABLE_EARLY_SUB": "Clients partis · clôture cette réservation maintenant",
    "LIVE_RELEASE_EARLY_SUCCESS": "Table libérée. Réservation clôturée à l'heure de fin sélectionnée.",
    "LIVE_RELEASE_EARLY_ERROR": "Impossible de libérer la table.",
    "LIVE_RELEASE_CHOICE_TITLE": "Table en cours d'utilisation",
    "LIVE_RELEASE_CHOICE_BODY": "Les clients sont-ils partis ? Clôturez la réservation avec l'heure actuelle comme fin. Ou si vous avez marqué l'arrivée par erreur, annulez uniquement l'arrivée — la réservation reste réservée.",
    "LIVE_RELEASE_CHOICE_UNDO": "Annuler l'arrivée (non installé)",
    "LIVE_RELEASE_CHOICE_CLOSE": "Clients partis — clôturer la réservation",
    "LIVE_UNDO_ARRIVAL_SUCCESS": "Arrivée annulée. La réservation est à nouveau réservée comme avant.",
    "LIVE_UNDO_ARRIVAL_ERROR": "Impossible d'annuler l'arrivée.",
    "LIVE_GUEST_SEATED_BADGE": "Installé",
    "LIVE_RES_COMBO_BADGE": "Combinaison",
    "LIVE_RES_PARTIAL_BADGE": "Séjour partiel",
    "LIVE_RES_PLACEMENT_MISSING": "Emplacement manquant",
    "LIVE_VISUAL_BLOCKED": "Bloquée",
    "LIVE_VISUAL_FREE": "Disponible (maintenant)",
    "LIVE_VISUAL_WAITING": "Réservée — en attente",
    "LIVE_VISUAL_SEATED": "Clients installés",
    "LIVE_VISUAL_DAY_BOOKED": "A des réservations (ce jour)",
    "LIVE_CANCEL_RESERVATION": "Annuler cette réservation",
    "LIVE_CANCEL_RESERVATION_SUCCESS": "Réservation annulée.",
    "LIVE_CANCEL_RESERVATION_ERROR": "Impossible d'annuler la réservation.",
    "LIVE_EDIT_RESERVATION": "Modifier la réservation",
    "LIVE_EDIT_RESERVATION_TITLE": "Modifier la réservation",
    "LIVE_EDIT_RESERVATION_HINT": "Choisissez d'abord la date, puis une heure de début selon la disponibilité. Vous pouvez aussi mettre à jour la taille du groupe et les notes. Lorsque les clients sont installés, seules les notes peuvent être modifiées.",
    "LIVE_EDIT_RES_DATE": "Date de réservation",
    "LIVE_EDIT_RES_DATE_HINT": "Après avoir changé le jour, les heures de début disponibles se rafraîchissent automatiquement.",
    "LIVE_EDIT_START_INVALID_FOR_DATE": "Choisissez une heure de début parmi les créneaux disponibles pour la date sélectionnée (ou changez la date ou la taille du groupe et réessayez).",
    "LIVE_EDIT_GUEST_SEATED_HINT": "Les clients sont installés : vous ne pouvez mettre à jour que les notes. Pour changer l'heure ou la table, libérez d'abord la table.",
    "LIVE_EDIT_SUCCESS": "Réservation mise à jour.",
    "LIVE_EDIT_ERROR": "Impossible de mettre à jour la réservation.",
    "LIVE_EDIT_NO_CHANGES": "Aucune modification à enregistrer.",
    "LIVE_MOVE_RESERVATION": "Déplacer vers une autre table",
    "LIVE_MOVE_RESERVATION_TITLE": "Déplacer la réservation",
    "LIVE_MOVE_RESERVATION_HINT": "Choisissez une autre table dans n'importe quelle salle. Même créneau et durée (doit être libre, y compris les retenues de combo).",
    "LIVE_MOVE_RESERVATION_HINT_COMBO": "Choisissez une autre combinaison ou une table seule dans n'importe quelle salle. Même créneau et durée ; toutes les tables à la destination doivent être libres.",
    "LIVE_MOVE_TARGET_DESTINATION": "Destination",
    "LIVE_MOVE_TARGET_REQUIRED": "Sélectionnez une destination.",
    "LIVE_MOVE_OPTION_COMBO_TITLE": "{{name}} — combo · {{seats}} places",
    "LIVE_MOVE_OPTION_COMBO_SUB": "{{room}} · {{slot}} · {{party}} convives · Tables : {{tables}}",
    "LIVE_MOVE_OPTION_TITLE": "{{name}} — max {{seats}} places",
    "LIVE_MOVE_OPTION_SUB": "{{room}} · Créneau {{slot}} · {{party}} convives (convient à cette réservation)",
    "LIVE_MOVE_TARGETS_LOADING": "Recherche des tables disponibles pour ce créneau…",
    "LIVE_MOVE_TARGETS_ERROR": "Impossible de charger les tables pour le déplacement.",
    "LIVE_MOVE_SEARCH_PLACEHOLDER": "Rechercher par table ou salle…",
    "LIVE_MOVE_TARGET_TABLE": "Table cible",
    "LIVE_MOVE_SUBMIT": "Déplacer",
    "LIVE_MOVE_SUCCESS": "Réservation déplacée.",
    "LIVE_MOVE_ERROR": "Impossible de déplacer la réservation.",
    "LIVE_MOVE_TABLE_REQUIRED": "Sélectionnez une table cible.",
    "LIVE_MOVE_NO_TARGETS": "Aucune table compatible dans aucune salle : suffisamment de places et un créneau libre pour cette plage horaire.",
    "LIVE_MOVE_NO_TARGETS_COMBO": "Aucune combinaison ou table compatible dans aucune salle : taille de groupe autorisée et un créneau libre sur toutes les tables concernées.",
    "LIVE_MOVE_NO_TARGETS_ONLY_ONE_COMBO": "L'établissement n'a que la combinaison actuelle «{{comboName}}» dans la salle «{{room}}» ({{totalSeats}} places physiques). Pour déplacer {{party}} convives, créez une autre combinaison (dans n'importe quelle salle) dans l'éditeur de plan. Les tables seules accueillent au plus {{maxTableSeats}} chacune.",
    "LIVE_RESERVATIONS": "Réservations",
    "LIVE_RES_COVERS": "{{count}} convives",
    "LIVE_RES_FINISHED": "Terminée",
    "LIVE_RES_FINISHED_NOTE": "Clôturée · créneau {{start}}–{{end}}",
    "LIVE_RESERVATIONS_BADGE": "réservations",
    "LIVE_NO_RESERVATIONS": "Aucune réservation pour ce jour.",
    "LIVE_COMBINATIONS": "Combinaisons",
    "LIVE_COMBOS_SHORT": "combo",
    "LIVE_TABLE_SEATS_TOOLTIP": "{{count}} couverts",
    "LIVE_TABLE_RES_TOOLTIP": "{{count}} réservations pour ce jour",
    "LIVE_STATUS_ACTIONS": "Statut de la table",
    "LIVE_STATUS_LABEL": "Statut",
    "LIVE_CYCLE_STATUS": "Statut suivant",
    "LIVE_FREE_CONFIRM_TITLE": "Annuler les réservations ?",
    "LIVE_FREE_CONFIRM_BODY": "La table {{name}} a des réservations pour ce jour. La passer en Libre et annuler ces réservations ? Cette action ne peut pas être annulée depuis ici.",
    "LIVE_FREE_CONFIRM_SUBMIT": "Annuler les réservations et passer en Libre",
    "LIVE_FREE_CONFIRM_BACK": "Conserver le statut actuel",
    "LIVE_FREE_SUCCESS": "Réservations annulées et table passée en Libre.",
    "LIVE_FREE_ERROR": "Impossible de libérer la table.",
    "LIVE_NOTES": "Notes du personnel",
    "LIVE_ERROR_LOAD": "Impossible de charger la vue en direct.",
    "LIVE_OPEN_EDITOR": "Ouvrir l'éditeur de plan de salle",
    "MANUAL_RES_TITLE": "Réservation de table — {{status}}",
    "MANUAL_RES_TITLE_RESERVE": "Nouvelle réservation de table",
    "MANUAL_RES_HINT": "Crée une réservation horodatée pour ce client. Les couleurs des tables en vue directe proviennent des réservations et de l'heure actuelle.",
    "MANUAL_RES_START": "Heure",
    "MANUAL_RES_END": "Heure de fin (optionnelle)",
    "MANUAL_RES_END_HINT": "Laissez vide pour utiliser la durée de réservation par défaut des paramètres chatbot/salle.",
    "MANUAL_RES_DURATION_HINT": "L'heure de fin est définie automatiquement selon la durée de réservation de votre restaurant.",
    "MANUAL_RES_SLOTS_LOADING": "Chargement des heures disponibles…",
    "MANUAL_RES_SLOTS_EMPTY": "Aucune heure réservable pour ce jour, cette taille de groupe ou cette table. Vérifiez les paramètres restaurant ou la disponibilité de la table.",
    "MANUAL_RES_SLOTS_LOAD_ERROR": "Impossible de charger les heures réservables.",
    "MANUAL_RES_PARTY": "Taille du groupe",
    "MANUAL_RES_COMBO_SELECT": "Combinaison de tables",
    "MANUAL_RES_COMBO_SINGLE_HINT": "La réservation utilise la combinaison « {{name}} » (toutes les tables liées sont retenues pour ce créneau).",
    "MANUAL_RES_NOTES": "Notes (optionnelles)",
    "MANUAL_RES_GUEST_CONTACT": "Client / contact",
    "MANUAL_RES_GUEST_PLACEHOLDER": "Choisir un contact ou un walk-in",
    "MANUAL_RES_SEARCH_CONTACTS": "Rechercher des contacts…",
    "MANUAL_RES_CREATE_CONTACT": "+ Nouveau contact",
    "MANUAL_RES_NO_CONTACT": "Sans nom / walk-in",
    "MANUAL_RES_FILL_GUEST": "Sélectionnez un contact ou un walk-in.",
    "MANUAL_RES_WALK_IN_DISPLAY": "Walk-in (sans contact)",
    "MANUAL_RES_CONTACT_MODE": "Client",
    "MANUAL_RES_EXISTING": "Contact existant",
    "MANUAL_RES_NEW": "Nouveau contact",
    "MANUAL_RES_SELECT_CONTACT": "Sélectionner un contact",
    "MANUAL_RES_FIRST": "Prénom",
    "MANUAL_RES_LAST": "Nom",
    "MANUAL_RES_PHONE": "Téléphone",
    "MANUAL_RES_EMAIL": "E-mail (optionnel)",
    "MANUAL_RES_SUBMIT": "Enregistrer la réservation",
    "MANUAL_RES_CANCEL": "Annuler",
    "MANUAL_RES_FILL_CONTACT": "Sélectionnez un contact.",
    "MANUAL_RES_FILL_NEW": "Le prénom, le nom et le téléphone sont obligatoires.",
    "MANUAL_RES_START_REQUIRED": "Veuillez sélectionner une heure.",
    "MANUAL_RES_SUCCESS": "Réservation enregistrée.",
    "MANUAL_RES_ERROR": "Impossible d'enregistrer la réservation.",
    "MANUAL_RES_CONTACTS_LOAD_ERROR": "Impossible de charger les contacts.",
    "LIVE_APPT_STATUS_CONFIRMED": "Confirmé",
    "LIVE_APPT_STATUS_PENDING": "En attente",
    "LIVE_APPT_STATUS_COMPLETED": "Terminé",
    "LIVE_APPT_STATUS_CANCELLED": "Annulé",
    "LIVE_APPT_STATUS_CANCELLED_BY_CLIENT": "Annulé par le client",
    "LIVE_APPT_STATUS_NO_SHOW": "Absence",
    "ANALYTICS_TITLE": "Analyses de salle",
    "ANALYTICS_SUBTITLE": "Réservations et utilisation des tables pour la période sélectionnée (dates UTC).",
    "ANALYTICS_FROM": "Du",
    "ANALYTICS_TO": "Au",
    "ANALYTICS_PRESET_7D": "7 derniers jours",
    "ANALYTICS_PRESET_30D": "30 derniers jours",
    "ANALYTICS_APPLY": "Appliquer",
    "ANALYTICS_LOADING": "Chargement des analyses…",
    "ANALYTICS_ERROR": "Impossible de charger les analyses. Vérifiez la plage de dates et réessayez.",
    "ANALYTICS_KPI_TOTAL": "Total des réservations",
    "ANALYTICS_KPI_WITH_TABLE": "Avec table assignée",
    "ANALYTICS_KPI_WITH_COMBO": "Avec combinaison de tables",
    "ANALYTICS_KPI_CONFIRMED": "Confirmées",
    "ANALYTICS_KPI_NO_SHOW": "Absences",
    "ANALYTICS_KPI_CANCELLED": "Annulées (toutes)",
    "ANALYTICS_CHART_BOOKINGS": "Réservations par jour",
    "ANALYTICS_CHART_STATUS": "Par statut",
    "ANALYTICS_CHART_HOUR": "Réservations par heure (heure de début)",
    "ANALYTICS_CHART_TOP_TABLES": "Top tables",
    "ANALYTICS_CHART_DAY_STATUS": "Statut opérationnel des tables par jour",
    "ANALYTICS_TOP_TABLES": "Top tables",
    "ANALYTICS_TOP_ROOMS": "Top salles",
    "ANALYTICS_RECENT": "Réservations récentes",
    "ANALYTICS_UNFULFILLED_TITLE": "Chat : demandes de table non satisfaites",
    "ANALYTICS_UNFULFILLED_HINT": "Enregistré lorsque le chatbot n'a trouvé aucune table après avoir cherché l'heure demandée et ±30 minutes.",
    "ANALYTICS_UNFULFILLED_EMPTY": "Aucune demande chat non satisfaite enregistrée.",
    "ANALYTICS_UNFULFILLED_COL_WHEN": "Enregistré à",
    "ANALYTICS_UNFULFILLED_COL_PARTY": "Convives",
    "ANALYTICS_UNFULFILLED_COL_OFFSETS": "Décalages essayés (min)",
    "ANALYTICS_NO_DATA": "Aucune donnée pour cette période.",
    "ANALYTICS_COL_TABLE": "Table",
    "ANALYTICS_COL_ROOM": "Salle",
    "ANALYTICS_COL_COUNT": "Nombre",
    "ANALYTICS_COL_DATE": "Date",
    "ANALYTICS_COL_TIME": "Heure",
    "ANALYTICS_COL_TITLE": "Titre",
    "ANALYTICS_COL_STATUS": "Statut"
  }
}
